var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommunityCenter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 502.96 412.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-17 {\n        fill: none;\n      }\n\n      .cls-2 {\n        isolation: isolate;\n      }\n\n      .cls-20, .cls-24, .cls-25, .cls-3, .cls-5 {\n        fill: #c2c7fb;\n      }\n\n      .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-22, .cls-3, .cls-31, .cls-32, .cls-34, .cls-4 {\n        stroke: #1228f3;\n      }\n\n      .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-24, .cls-25, .cls-27, .cls-3, .cls-31, .cls-32, .cls-34, .cls-4 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-24, .cls-25, .cls-27, .cls-3, .cls-31, .cls-32, .cls-34, .cls-4 {\n        stroke-width: 0.76px;\n      }\n\n      .cls-27, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-28, .cls-6 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-7 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-8 {\n        clip-path: url(#clip-path-2);\n      }\n\n      .cls-9 {\n        clip-path: url(#clip-path-3);\n      }\n\n      .cls-10 {\n        clip-path: url(#clip-path-4);\n      }\n\n      .cls-11, .cls-31 {\n        fill: #1228f3;\n      }\n\n      .cls-12, .cls-13 {\n        fill: #02eec4;\n      }\n\n      .cls-14 {\n        fill: #ffe1cd;\n      }\n\n      .cls-15 {\n        fill: #fd672e;\n      }\n\n      .cls-16 {\n        fill: #fdce45;\n      }\n\n      .cls-18 {\n        fill: #ffd9bf;\n      }\n\n      .cls-19, .cls-23 {\n        fill: #3c4ef5;\n      }\n\n      .cls-20, .cls-21, .cls-27 {\n        stroke: #1228f2;\n      }\n\n      .cls-21, .cls-28 {\n        fill: #c1c6fa;\n      }\n\n      .cls-22 {\n        fill: #fecf45;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-24 {\n        stroke: #343df9;\n      }\n\n      .cls-25 {\n        stroke: #1227f2;\n      }\n\n      .cls-26 {\n        fill: #1227f2;\n      }\n\n      .cls-29 {\n        clip-path: url(#clip-path-5);\n      }\n\n      .cls-30 {\n        clip-path: url(#clip-path-6);\n      }\n\n      .cls-32 {\n        fill: #fdf400;\n      }\n\n      .cls-33 {\n        fill: #343df9;\n      }\n\n      .cls-34 {\n        fill: #fe672e;\n      }\n\n      .cls-35 {\n        clip-path: url(#clip-path-7);\n      }\n\n      .cls-36 {\n        clip-path: url(#clip-path-8);\n      }\n\n      .cls-37 {\n        clip-path: url(#clip-path-9);\n      }\n\n      .cls-38 {\n        fill: #1227f3;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-718.62 -265.26)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "922.6 434.51 935.4 427.07 948.28 434.51 935.48 441.95 922.6 434.51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-718.62 -265.26)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "942.9 589 970.12 573.17 997.2 588.81 969.98 604.63 942.9 589"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-718.62 -265.26)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1000.2 583.4 1027.43 567.58 1054.5 583.22 1027.28 599.04 1000.2 583.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(-718.62 -265.26)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "717.63 497.96 969.1 351.82 1222.21 497.95 970.74 644.09 717.63 497.96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(-718.62 -265.26)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "995.87 436.05 1009.06 428.39 1022.34 436.06 1009.15 443.72 995.87 436.05"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(-718.62 -265.26)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1023.7 427.4 1036.89 419.74 1050.17 427.41 1036.98 435.07 1023.7 427.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(-718.62 -265.26)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "879.18 498.77 898.32 487.65 917.58 498.77 898.45 509.9 879.18 498.77"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(-718.62 -265.26)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "907.83 487.13 926.97 476.01 946.23 487.13 927.09 498.25 907.83 487.13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(-718.62 -265.26)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "975.75 307.69 975.8 286.52 1043.19 325.43 1043.13 346.6 975.75 307.69"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0.38 233.29 251.48 378.3 251.48 412.32 0.38 267.48 0.38 233.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "0.82 233.54 251.92 378.55 502.58 233.29 251.93 88.62 0.82 233.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "502.58 233.29 251.48 378.3 251.48 412.32 502.58 267.48 502.58 233.29"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "397.92 273.97 387.53 280.09 357.17 262.71 368.13 256.02 397.92 273.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "179.92 172.29 190.31 178.41 220.67 161.03 209.71 154.34 179.92 172.29"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M941.84,430.79a14.17,14.17,0,0,0-12.84,0c-3.53,2-3.52,5.39,0,7.44a14.17,14.17,0,0,0,12.84,0c3.54-2.05,3.52-5.39,0-7.44",
    transform: "translate(-718.62 -265.26)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M983.68,581a22.65,22.65,0,0,0-2.26-1.12c-8.63-3.65-20.7-2.57-27,2.41-5.67,4.51-4.66,10.67,2,14.51a20.87,20.87,0,0,0,2.27,1.13c8.63,3.64,20.7,2.57,27-2.42,5.68-4.51,4.66-10.67-2-14.51",
    transform: "translate(-718.62 -265.26)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1041,575.41a19.19,19.19,0,0,0-2.27-1.12c-8.62-3.65-20.7-2.58-27,2.41-5.68,4.51-4.66,10.68,2,14.51a19,19,0,0,0,2.26,1.12c8.62,3.65,20.69,2.57,27-2.41,5.68-4.51,4.65-10.67-2-14.51",
    transform: "translate(-718.62 -265.26)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M926.63,523.11c-24-13.87-24.15-36.44-.28-50.31s62.83-13.87,86.86,0,24.16,36.44.28,50.32-62.83,13.87-86.86,0m179.25-91.7L1084.35,419,1023,454.66l-.26-.1c-15.54-6.39-33.9-9.76-53.08-9.76s-37.5,3.38-53,9.76l-.26.1L854.6,419l-21.39,12.44L895,467.1l-.18.15c-11,9-16.73,19.59-16.67,30.71s5.94,21.73,17,30.71l.18.15L834,564.5l21.53,12.43,61.39-35.68.27.11c15.53,6.38,33.88,9.75,53.07,9.76s37.5-3.38,53-9.76l.26-.11,61.8,35.68,21.4-12.43-61.8-35.68.18-.15c11-9,16.73-19.6,16.68-30.71s-6-21.74-17-30.71l-.19-.16,61.39-35.68",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M833.21,431.42,854.6,419l61.8,35.68.26-.1c15.46-6.38,33.78-9.76,53-9.76s37.54,3.37,53.08,9.76l.26.1L1084.35,419l21.53,12.43-61.39,35.68.19.16c11.06,9,17,19.59,17,30.71S1056,519.69,1045,528.67l-.18.15,61.8,35.68-21.4,12.43-61.8-35.68-.26.11c-15.46,6.38-33.77,9.75-53,9.76s-37.54-3.38-53.07-9.76l-.27-.11-61.39,35.68L834,564.5l61.39-35.68-.18-.15c-11.08-9-17-19.6-17-30.71s5.71-21.74,16.67-30.71l.18-.15-61.79-35.68m273.75,0-22.6-13.05-61.49,35.73c-15.61-6.36-34-9.73-53.26-9.73s-37.59,3.37-53.14,9.73l-61.88-35.73-22.46,13.05L894,467.14c-10.93,9-16.68,19.67-16.62,30.81s5.93,21.8,17,30.82L832.88,564.5l22.61,13L917,541.82c15.61,6.37,34,9.74,53.25,9.73s37.61-3.36,53.15-9.73l61.88,35.73,22.46-13-61.88-35.73c10.94-9,16.69-19.67,16.62-30.81s-5.93-21.8-17-30.82L1107,431.41",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1012.68,473.11c-11.87-6.85-27.42-10.27-43-10.27s-31,3.42-42.84,10.27S909.24,489,909.29,498s6,18,17.87,24.85,27.43,10.28,43,10.28,31-3.42,42.84-10.27S1030.61,507,1030.55,498s-6-18-17.87-24.85",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M927.16,522.8C915.3,516,909.34,507,909.29,498s5.81-18,17.59-24.84,27.31-10.27,42.84-10.27,31.09,3.42,43,10.27S1030.51,489,1030.55,498s-5.8,18-17.59,24.85-27.31,10.27-42.84,10.27-31.09-3.42-43-10.28m86.05-50c-24-13.87-63-13.87-86.86,0s-23.75,36.44.28,50.31,63,13.88,86.86,0,23.75-36.45-.28-50.32",
    transform: "translate(-718.62 -265.26)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M986.45,591.91c.95.59,4.59,3,2.61,3.86s-4.22-.63-5.48-1.57c-.92-.69-1.93-3-.81-3.61C983.68,590.07,985.1,591.06,986.45,591.91Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M984.06,585.48c.18,2.21.74,5.86,1,6.87s-2.58,1.85-3.1.22-1.49-4.7-1.76-5.88S983.94,584.12,984.06,585.48Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M975.36,569.65l3.1,8.12c.39,1-.55,3-1.43,1.79s-4-5.9-5.08-7.34S974.86,568.34,975.36,569.65Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M974.61,579.56a17.72,17.72,0,0,1,5.73-2.3c1.31-.27,2.83,1.09,3,2.42s.67,4.53.7,5.8c0,1.46-3.43,2.42-4.17.85a23.91,23.91,0,0,0-1.31-2.35c-.24-.42-1.76,1.61-4.73.95s-3.27-2.44-3.27-2.44",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M978.29,594.09c.88.66,7.69,4.74,8.47,5.22s2-1.68.7-2.94-5.92-5.7-6.69-6.26S976.55,592.79,978.29,594.09Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M973.52,584.48a53.94,53.94,0,0,1,7.76,6.11c-1.69-.15-2.75,2.35-2.75,3.81a48.93,48.93,0,0,0-6.58-3.07c-7.18-1.41-7.82-4.44-8.17-6.17-.14-.7,8.71-5.44,8.88-5.48s.38,1.81.38,1.81",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M973.24,568.69c1.76,1.33-.39,7,1.37,10.87-1.88,5.42-8.46,5.76-10.57,6.71-.48-1.47-2.56-2.94-2.72-11.07-1.55-6.8,2.1-9.17,6.55-9.81,3.23-.46,5.09-1,7.24,3.44a1.79,1.79,0,0,1-1.13,2.69",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M964.55,575.34c-.92,2-5.26,11-5.64,11.8s-.58,1.43-1.66,1.79-2.06.73-2.21.38.67-.77,1.26-1.18-2.35-.29-2.94-.28c-1.53,0-.76-1.94-.24-2.26,1.31-.79,2.68.24,3.3.48a.86.86,0,0,0,1.25-.59c.23-1.6,2.47-11.41,2.47-11.41C960.57,572.66,965,574.36,964.55,575.34Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M965.78,566.09a2.14,2.14,0,0,0,2.78,2c1.8-.28,1.38-1.63,1.14-2v-2.67h-3.92Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 249.07,
    cy: 294.42,
    r: 5.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M965.55,556.17a3,3,0,0,0,2.78.39c1.42-.53,2.55-1.67,4,.51.7-2.54-1.88-5.51-4.91-5-7,1.09-6.2,6.11-5.42,8.88-1.13,3.05-2,6.14-.61,8.82,1-2.72,3-3.31,4.38-3.87C966.43,562.33,966.57,558.8,965.55,556.17Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M966.31,572.27c-.53.93-.77,1.71-1.45,2.76-.85,1.32-4.73.11-4.72-1a12.2,12.2,0,0,1,1-3.89",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 250.01,
    y1: 294.87,
    x2: 250.01,
    y2: 295.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 253.09,
    y1: 294.08,
    x2: 253.09,
    y2: 294.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M969.28,562.61a1.85,1.85,0,0,0,1.81-.28",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M971,560.58a.59.59,0,0,1-.62.88",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 249.16,
    y1: 294.14,
    x2: 249.97,
    y2: 293.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 252.53,
    y1: 293,
    x2: 253.38,
    y2: 293.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M988.7,600.49c-1.08.24-2.11-1.15-2.19-2.68s-.3-5.28,1.29-6,2,3.72,2,4.7S990.07,600.19,988.7,600.49Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1006.41,595.07c1.52,1.08.2,2.92-1.85,4.07s-3.86,2.26-5.71,1.18-.26-3.2,2.59-4.68S1005.16,594.18,1006.41,595.07Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1034.79,582a6.82,6.82,0,0,0,2,1.7,5.45,5.45,0,0,0,1.93.64c1,.23,1.95.52,2.31.21.53-.46,0-.51-1-1.54-.56-.58,2.3-.93,2.66-1.15s.07-1.15-.87-1.65a2.75,2.75,0,0,0-2.47,0,6.44,6.44,0,0,1-1.34.93c-.33.21-1.09-.5-1.54-1.13S1034.22,581.26,1034.79,582Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1004.75,592.77c-.37.53-1.43,1.87-1.81,2.45-.64,1,1.15,2.22,2.3,1.4.91-.65,1.74-1.52,2.57-2.2a1.47,1.47,0,0,0-.24-2.31A2.42,2.42,0,0,0,1004.75,592.77Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1020.06,572.32c-2-2-2-4.86-.93-6s2.9-1,4.54-.25a24.77,24.77,0,0,1,5.23,4c.9,1.15-.12,4.67-.51,5.5",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1025.07,566.55a6.45,6.45,0,0,1,4,1.35,22.37,22.37,0,0,1,4,5.74c1.92,3.39,3.29,5.2,4.26,6.91s-1.81,3.24-3,1.58-6.27-7.59-7.76-9.23",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1019,582.58l-3.77-1.44c-1.56-.59-2.87-.58-3.86.82-.79,1.1-5.06,7-6.49,9.32s3.57,4.05,4.7,2.67,3.65-4.62,4.17-5.32.83-1.91,2.29-1.54c2.25.55,5.72,1.55,9.07.28s2.19-4.74,1.61-5.54-5.67,0-5.67,0a8,8,0,0,0-1.94-2c-1-.59-10-5.26-12.43-5.1-.28,0-1.38,4.72.9,5.22a9.49,9.49,0,0,1,3.55,1.48",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1019.72,570c-.22,1.56-.22,4.05-1.22,5.42s-2.45,5.92,1.22,7.55,6.39.13,7-.72c1-1.43.34-4.58,1.88-7",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1023,564.75c0,.39,0,1.23,0,2a1.42,1.42,0,0,0,1.35,1.35c1.35.11,2.28-.48,2.34-1.64,0-.42,0-1,0-1.58,0-2.28-1.83-.85-2.25-.9S1023,564.75,1023,564.75Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 305.92,
    cy: 295.29,
    r: 5.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1025.07,562v1.22c0,.26-.31.41-.71.15s-1.19-.88-1.53-1.13a.8.8,0,0,1-.33-.79c0-.28,0-.37,0-.88s.26-.39.51-.23,1.46,1,1.67,1.16S1025.07,561.73,1025.07,562Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 303.88,
    y1: 295.29,
    x2: 303.08,
    y2: 294.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 306.16,
    y1: 295.29,
    x2: 305.27,
    y2: 294.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 303.08,
    y1: 293.49,
    x2: 302.2,
    y2: 293.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1022.19,562.86c-.17-.07-.55-.23-.61-.39",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1023.34,564a2.74,2.74,0,0,1-1.1-.27",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1021.7,559.78V561c0,.26-.31.41-.71.15s-1.19-.88-1.53-1.14a.78.78,0,0,1-.33-.78c0-.29,0-.37,0-.89s.26-.38.51-.22,1.46,1,1.67,1.16S1021.7,559.53,1021.7,559.78Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1004.26,580c-2.24-1.91.35-6.84,4.25-4.82a23.83,23.83,0,0,1,5.08,4c1.6,2-2.34,4.91-4.66,3.94A17.06,17.06,0,0,1,1004.26,580Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1032.47,557.61a.76.76,0,0,0-.75-.77h0a3.59,3.59,0,0,0-.19-1.65.76.76,0,0,0-1-.42.78.78,0,0,0-.18.11,3.51,3.51,0,0,0-.72-1.18.77.77,0,0,0-1.08,0l-.11.15a3.73,3.73,0,0,0-1.16-1.77.78.78,0,0,0-1.07.21.72.72,0,0,0-.12.4.78.78,0,0,0-.43.05,3.36,3.36,0,0,0-.55-.61.77.77,0,0,0-1.07.1.73.73,0,0,0-.16.36,3.21,3.21,0,0,0-1.07-.78.76.76,0,0,0-1,.45.78.78,0,0,0,.18.8l-.1,0a.77.77,0,0,0-.91.57.74.74,0,0,0,0,.47,2.34,2.34,0,0,0-1-.25.75.75,0,0,0-.75.76.78.78,0,0,0,.75.76c.2,0,.82.27.82,1.28,0,.59.89,1,1.28,1h.08a.81.81,0,0,0,.22-.07.77.77,0,0,1,0,.15.76.76,0,0,0,.76.68h.08a.75.75,0,0,0,.6-.42,2,2,0,0,1,0,.26.76.76,0,0,0,.75.68h.08a.73.73,0,0,0,.57-.38.76.76,0,0,0,.71.5h.08a.77.77,0,0,0,.46-.22s0,0,0,0a.76.76,0,0,0,.75.68h.08a.32.32,0,0,0,.14,0,.66.66,0,0,0,.11.24.74.74,0,0,0-.27.31.59.59,0,0,0,.46.89c-.24.26.06,1,1,.6,0,0-.55,1.21-.58,1.25a.6.6,0,0,0,.16.92c.55.37.45.36.88.36a1.43,1.43,0,0,0,1.08-.52l0,0a.76.76,0,0,0,.27-1,.83.83,0,0,0-.16-.21,2.1,2.1,0,0,0,.33-.26,1,1,0,0,0,.08-1.23l-.09-.08a1.15,1.15,0,0,0,.62-.37.8.8,0,0,0,.2-.65A3.48,3.48,0,0,0,1032.47,557.61Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1028.31,561.65a1.2,1.2,0,0,1,.85-.08,1.45,1.45,0,0,1-.77,2.77,1.18,1.18,0,0,1-.79-.73",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1009.4,582.07a21.63,21.63,0,0,0,1.72,1.52c.45.31,3.58-1.08,3-1.63a23.28,23.28,0,0,0-2.32-1.64C1010.29,579.26,1008.46,581.19,1009.4,582.07Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1016.51,582.82c.31.8-.3,2.92-2.7,3.72-3.52,1.16-5.21.38-5.55-.82s1.08-2.9,3.42-3.65C1013.81,581.38,1016,581.63,1016.51,582.82Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "367.56 256.53 357.17 262.65 357.34 251.06 367.48 245.27 367.56 256.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "387.67 268.5 387.67 268.36 386.38 267.62 386.38 267.62 386.38 267.62 357.28 250.8 357.28 250.78 356.03 250.07 356.03 251.6 356.03 261.75 357.28 262.57 357.28 252.33 386.38 269.2 386.38 279.12 387.64 279.95 387.7 268.52 387.67 268.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "362.82 246.06 366.05 244.11 396.67 261.87 393.26 263.77 362.82 246.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "359.42 247.94 362.82 246.06 393.26 263.77 389.83 265.69 359.42 247.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "356.03 250 359.42 247.94 389.83 265.69 386.47 267.71 356.03 250"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1113,523.5a49.4,49.4,0,0,1-8.72,4.48c-2,.63-10.66-1.71-8.54-5.91",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1112.89,536.45c-.35,1-.52,3.85,1.46,3.72s5.9-2.52,6.68-3.37.65-1.83-.38-2.19-5.19.26-6.18.84A17.28,17.28,0,0,0,1112.89,536.45Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1105,521.44a73.32,73.32,0,0,1,9.1-3.7c1.28-.3,2.91.55,3.16,2.9s.27,12.21.27,13.68c0,2.13-5,3.6-5,1V523.89",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1093.54,508.33c-.57,1.31.89,7.6,1.78,9.81s2.59,2.57,3.91,2,3.45-1.36,4.2-2.15-1.25-2.26-2-2.27-2.92.1-3.37.16-.9-2.26-.76-2.74S1095.16,504.63,1093.54,508.33Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1112.03,
    y: 501.16,
    width: 11.3,
    height: 14.31,
    rx: 1.14,
    transform: "translate(-578.69 985.75) rotate(-61.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1120,517.53l-5.93,3.35a.88.88,0,0,1-.85,0l-10.77-5.8a.88.88,0,0,1,0-1.54l5.93-3.34a.89.89,0,0,1,.85,0l10.78,5.81A.88.88,0,0,1,1120,517.53Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1106.66,516.21l3.18,1.83a.4.4,0,0,0,.38,0l1-.58c.11-.06.13-.16,0-.21l-3.18-1.84a.4.4,0,0,0-.38,0l-1,.58C1106.57,516.05,1106.56,516.15,1106.66,516.21Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1117.77,516.75l.93.53s.07,0,.11,0l.29-.17s0-.05,0-.07l-.93-.53a.11.11,0,0,0-.11,0l-.29.17S1117.74,516.73,1117.77,516.75Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1117,516.27l.3.18a.17.17,0,0,0,.12,0l.29-.17s0,0,0-.06l-.31-.18a.14.14,0,0,0-.11,0l-.3.17S1116.92,516.25,1117,516.27Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1116.12,515.79l.31.18a.11.11,0,0,0,.11,0l.29-.17s0,0,0-.07l-.31-.17a.11.11,0,0,0-.11,0l-.29.17S1116.09,515.78,1116.12,515.79Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1115.3,515.32l.31.18a.15.15,0,0,0,.11,0l.29-.17s0-.05,0-.06l-.31-.18a.14.14,0,0,0-.11,0l-.3.17A0,0,0,0,0,1115.3,515.32Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1114.47,514.84l.31.18a.14.14,0,0,0,.11,0l.3-.17a0,0,0,0,0,0-.07l-.31-.18a.15.15,0,0,0-.11,0l-.29.17S1114.44,514.83,1114.47,514.84Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1113.65,514.37l.31.17a.11.11,0,0,0,.11,0l.29-.17s0,0,0-.06l-.31-.18a.11.11,0,0,0-.11,0l-.29.17S1113.62,514.35,1113.65,514.37Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1112.82,513.89l.31.18a.11.11,0,0,0,.11,0l.3-.16a0,0,0,0,0,0-.07l-.31-.18a.14.14,0,0,0-.11,0l-.3.17S1112.8,513.87,1112.82,513.89Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1112,513.41l.31.18a.11.11,0,0,0,.11,0l.29-.17s0,0,0-.06l-.31-.18a.11.11,0,0,0-.11,0l-.29.17S1112,513.4,1112,513.41Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1111.18,512.94l.31.18a.15.15,0,0,0,.11,0l.29-.17s0,0,0-.06l-.31-.18a.11.11,0,0,0-.11,0l-.3.16A0,0,0,0,0,1111.18,512.94Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1110.35,512.46l.31.18a.11.11,0,0,0,.11,0l.3-.17a0,0,0,0,0,0-.07l-.31-.17a.11.11,0,0,0-.11,0l-.29.17S1110.32,512.45,1110.35,512.46Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1117,517.22l.92.54a.14.14,0,0,0,.11,0l.3-.17s0-.05,0-.06l-.92-.54a.14.14,0,0,0-.11,0l-.3.17S1116.92,517.2,1117,517.22Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1107.26,511.63l.93.54a.14.14,0,0,0,.11,0l.29-.17s0-.05,0-.06l-.93-.54a.15.15,0,0,0-.11,0l-.29.17S1107.23,511.61,1107.26,511.63Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1116.12,516.75l.31.17a.11.11,0,0,0,.11,0l.29-.17s0,0,0-.06l-.31-.18a.11.11,0,0,0-.11,0l-.29.17S1116.09,516.73,1116.12,516.75Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1115.3,516.27l.31.18a.15.15,0,0,0,.11,0l.29-.17s0,0,0-.06l-.31-.18a.14.14,0,0,0-.11,0l-.3.17S1115.27,516.25,1115.3,516.27Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1114.47,515.79l.31.18a.11.11,0,0,0,.11,0l.3-.17a0,0,0,0,0,0-.07l-.31-.17a.11.11,0,0,0-.11,0l-.29.17S1114.44,515.78,1114.47,515.79Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1113.65,515.32l.31.18a.14.14,0,0,0,.11,0l.29-.17s0-.05,0-.06l-.31-.18a.14.14,0,0,0-.11,0l-.29.17S1113.62,515.3,1113.65,515.32Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1112.82,514.84l.31.18a.14.14,0,0,0,.11,0l.3-.17a0,0,0,0,0,0-.07l-.31-.18a.14.14,0,0,0-.11,0l-.3.17S1112.8,514.83,1112.82,514.84Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1112,514.37l.31.17a.11.11,0,0,0,.11,0l.29-.17s0,0,0-.06l-.31-.18a.11.11,0,0,0-.11,0l-.29.17S1112,514.35,1112,514.37Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1111.18,513.89l.31.18s.07,0,.11,0l.29-.17s0,0,0-.06l-.31-.18a.14.14,0,0,0-.11,0l-.3.17S1111.15,513.87,1111.18,513.89Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1110.35,513.41l.31.18a.11.11,0,0,0,.11,0l.3-.17s0,0,0-.06l-.31-.18a.11.11,0,0,0-.11,0l-.29.17S1110.32,513.4,1110.35,513.41Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1109.53,512.94l.31.18a.14.14,0,0,0,.11,0l.29-.17s0,0,0-.06l-.31-.18a.11.11,0,0,0-.11,0l-.29.16S1109.5,512.92,1109.53,512.94Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1108.7,512.46l.31.18a.11.11,0,0,0,.11,0l.3-.17a0,0,0,0,0,0-.07l-.3-.17a.13.13,0,0,0-.12,0l-.29.17S1108.68,512.45,1108.7,512.46Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1116.12,517.7l.93.53a.11.11,0,0,0,.11,0l.29-.17s0,0,0-.07l-.93-.53a.11.11,0,0,0-.11,0l-.29.17S1116.09,517.68,1116.12,517.7Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1106.44,512.11l.92.53a.13.13,0,0,0,.12,0l.29-.17a0,0,0,0,0,0-.07l-.93-.53a.11.11,0,0,0-.11,0l-.29.17S1106.41,512.09,1106.44,512.11Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1115.3,517.22l.31.18s.07,0,.11,0l.29-.16s0-.05,0-.07l-.31-.18a.14.14,0,0,0-.11,0l-.3.17S1115.27,517.2,1115.3,517.22Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1114.47,516.75l.31.17a.11.11,0,0,0,.11,0l.3-.17s0,0,0-.06l-.31-.18a.11.11,0,0,0-.11,0l-.29.17S1114.44,516.73,1114.47,516.75Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1113.65,516.27l.31.18a.14.14,0,0,0,.11,0l.29-.17s0,0,0-.06l-.31-.18a.14.14,0,0,0-.11,0l-.29.17S1113.62,516.25,1113.65,516.27Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1112.82,515.79l.31.18a.11.11,0,0,0,.11,0l.3-.17a0,0,0,0,0,0-.07l-.31-.17a.11.11,0,0,0-.11,0l-.3.17S1112.8,515.78,1112.82,515.79Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1112,515.32l.31.18a.14.14,0,0,0,.11,0l.29-.17s0-.05,0-.06l-.31-.18a.14.14,0,0,0-.11,0l-.29.17S1112,515.3,1112,515.32Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1111.18,514.84l.31.18s.07,0,.11,0l.29-.17s0-.05,0-.07l-.31-.18a.14.14,0,0,0-.11,0l-.3.17S1111.15,514.83,1111.18,514.84Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1110.35,514.37l.31.17a.11.11,0,0,0,.11,0l.3-.17s0,0,0-.06l-.31-.18a.11.11,0,0,0-.11,0l-.29.17S1110.32,514.35,1110.35,514.37Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1109.53,513.89l.31.18a.11.11,0,0,0,.11,0l.29-.17s0,0,0-.06l-.31-.18a.14.14,0,0,0-.11,0l-.29.17S1109.5,513.87,1109.53,513.89Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1108.7,513.41l.31.18a.11.11,0,0,0,.11,0l.3-.17s0,0,0-.06l-.3-.18a.13.13,0,0,0-.12,0l-.29.17S1108.68,513.4,1108.7,513.41Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1107.88,512.94l.31.18a.14.14,0,0,0,.11,0l.29-.17s0,0,0-.06l-.31-.18a.11.11,0,0,0-.11,0l-.29.16S1107.85,512.92,1107.88,512.94Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1114.47,518.65l.93.53a.11.11,0,0,0,.11,0l.29-.17s0,0,0-.06l-.93-.54s-.07,0-.11,0l-.29.16S1114.44,518.63,1114.47,518.65Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1104.79,513.06l.93.53a.11.11,0,0,0,.11,0l.29-.17s0,0,0-.06l-.93-.54a.14.14,0,0,0-.11,0l-.29.17S1104.76,513,1104.79,513.06Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1113.65,518.17l.31.18a.11.11,0,0,0,.11,0l.29-.17s0,0,0-.07l-.31-.18a.14.14,0,0,0-.11,0l-.29.17S1113.62,518.16,1113.65,518.17Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1113.55,517.7l-.31.18h-.11l-6.07-3.51s0,0,0-.06l.3-.18a.11.11,0,0,1,.11,0l6.08,3.51S1113.57,517.68,1113.55,517.7Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1106.23,513.89l.31.18a.11.11,0,0,0,.11,0l.29-.17s0,0,0-.06l-.31-.18a.14.14,0,0,0-.11,0l-.29.17S1106.2,513.87,1106.23,513.89Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1114.47,517.7l1.75,1a.14.14,0,0,0,.11,0l.3-.17s0,0,0-.06l-1.76-1a.11.11,0,0,0-.11,0l-.29.17S1114.44,517.68,1114.47,517.7Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1105.61,512.58l1.75,1a.13.13,0,0,0,.12,0l.29-.17s0,0,0-.06l-1.75-1a.17.17,0,0,0-.12,0l-.29.17S1105.58,512.57,1105.61,512.58Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1113.65,517.22l.31.18a.11.11,0,0,0,.11,0l.29-.16s0-.05,0-.07l-.31-.18a.14.14,0,0,0-.11,0l-.29.17S1113.62,517.2,1113.65,517.22Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1112.82,516.75l.31.17a.11.11,0,0,0,.11,0l.3-.17s0,0,0-.06l-.31-.18a.11.11,0,0,0-.11,0l-.3.17A0,0,0,0,0,1112.82,516.75Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1112,516.27l.31.18a.14.14,0,0,0,.11,0l.29-.17s0,0,0-.06l-.31-.18a.14.14,0,0,0-.11,0l-.29.17S1112,516.25,1112,516.27Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1111.18,515.79l.31.18a.11.11,0,0,0,.11,0l.29-.17s0,0,0-.07l-.31-.17a.11.11,0,0,0-.11,0l-.3.17S1111.15,515.78,1111.18,515.79Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1110.35,515.32l.31.18a.14.14,0,0,0,.11,0l.3-.17s0-.05,0-.06l-.31-.18s-.07,0-.11,0l-.29.17S1110.32,515.3,1110.35,515.32Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1109.53,514.84l.31.18a.14.14,0,0,0,.11,0l.29-.17s0-.05,0-.07l-.31-.18a.14.14,0,0,0-.11,0l-.29.17S1109.5,514.83,1109.53,514.84Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1108.7,514.37l.31.17a.11.11,0,0,0,.11,0l.3-.17s0,0,0-.06l-.3-.18a.13.13,0,0,0-.12,0l-.29.17A0,0,0,0,0,1108.7,514.37Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1107.88,513.89l.31.18a.11.11,0,0,0,.11,0l.29-.17s0,0,0-.06l-.31-.18a.14.14,0,0,0-.11,0l-.29.17S1107.85,513.87,1107.88,513.89Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1107.79,520.3c.07-2.94-1.77-.89-.68-7.43.21-1.26-1.71-4-2.31-4.34-1.88-1-2.15-1.16-3-1.65-1.52.12-4.15-2-5-2.2-1.28-.63-4.44-.54-3.9,4.07s2.54,10.83,2.9,13C1096,522.94,1104.54,527.56,1107.79,520.3Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1102.65,503.77c-.53,1.24-.93,1.68-.85,3.11-2.37.66-3.52,0-4-.4,0-.79.15-2.06.12-2.71C1099.29,504.35,1102,504.23,1102.65,503.77Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1107.47,495.09a6.74,6.74,0,1,0-3.24,9A6.73,6.73,0,0,0,1107.47,495.09Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1098.52,491.85a6.73,6.73,0,0,1,5.5-.1,6.16,6.16,0,0,1,3.31,3.07c-3.73-.73-1.6,3.48-3.1,3.5-4.21.08-2.15,2.16-3.08,4.39a2.58,2.58,0,0,1-3.38.92,6.19,6.19,0,0,1-3.13-5.52A6.72,6.72,0,0,1,1098.52,491.85Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1103.51,498.37a1.26,1.26,0,0,0-.84-.26,1.49,1.49,0,0,0,.22,2.94,1.26,1.26,0,0,0,.94-.57",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1101.8,509.84c.66-1.19,3.13-3.07,4.61.91a25,25,0,0,1,1.69,8.31c.08,1.06-.07,3.09-1,3",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1107.33,498.82c-.31.82-.39,1-.39,1",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1113.29,519a3.19,3.19,0,0,0,1.55-.62,13.36,13.36,0,0,1,1.82-2.71c.71-.62,2-1.14.94.16-.7.83-.12,1.55.51,1.2a20.17,20.17,0,0,1,2.42-.91s-.17,2.26-1,2.85a10.44,10.44,0,0,1-3.94,1.1,7.19,7.19,0,0,0-2.4,1.21s-.92-.34-1-.89S1112.74,519.13,1113.29,519Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1103.25,515.81a24.59,24.59,0,0,0,1.7,5.63c.49,1.23,2.63,2,5.22,1.13a41.35,41.35,0,0,0,4.11-1.68c.8-.3.55-2.59-.81-2.44s-6,.52-6,.52",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 1112.9,
    y: 502.06,
    width: 9.57,
    height: 12.52,
    rx: 1.14,
    transform: "translate(-578.69 985.75) rotate(-61.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1118,480.91h6.7a6.25,6.25,0,0,1,6.23,6.23h0a6.24,6.24,0,0,1-6.23,6.23h-9.09l-2.9,3a.55.55,0,0,1-.94-.38v-8.88A6.26,6.26,0,0,1,1118,480.91Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "210.39 154.99 220.79 161.11 220.62 149.52 210.48 143.74 210.39 154.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "190.29 166.96 190.29 166.82 191.57 166.08 191.57 166.08 191.57 166.08 220.67 149.26 220.67 149.24 221.93 148.53 221.93 150.06 221.93 160.21 220.67 161.03 220.67 150.79 191.57 167.66 191.57 177.58 190.31 178.41 190.26 166.98 190.29 166.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "180.01 161.03 190.29 166.82 191.57 166.08 181.29 160.33 180.01 161.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "179.92 172.29 190.31 178.41 190.15 166.82 180.01 161.03 179.92 172.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "215.13 144.52 211.9 142.57 181.29 160.33 184.69 162.24 215.13 144.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "218.54 146.41 215.13 144.52 184.69 162.24 188.12 164.15 218.54 146.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "221.93 148.46 218.54 146.41 188.12 164.15 191.49 166.18 221.93 148.46"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1163.74,475c0-1.07-.89-2-2.24-2.59l0,0-29.17-15.67h0a8,8,0,0,0-3.59-.79c-3,0-5.45,1.42-5.5,3.19h0v7.21h0a3.09,3.09,0,0,0,2,2.42h0l29,15.61a7.75,7.75,0,0,0,3.9.95c2.93,0,5.32-1.35,5.48-3.06,0,0,0,0,0-.05V475Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1161.54,472.56h0l-29.17-15.68h0a8,8,0,0,0-3.59-.79c-3,0-5.5,1.45-5.5,3.24a3.06,3.06,0,0,0,2.06,2.53h0l29,15.6a7.78,7.78,0,0,0,3.9,1c3,0,5.5-1.45,5.5-3.24C1163.79,474.1,1162.9,473.15,1161.54,472.56Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 295.06,
    cy: 128.4,
    rx: 10.4,
    ry: 6.09
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "295.31 66.63 295.13 130.35 291.61 128.31 291.79 64.6 295.31 66.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "295.31 66.63 298.52 64.76 298.34 128.48 295.13 130.35 295.31 66.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "291.79 64.6 295 62.73 298.52 64.76 295.31 66.63 291.79 64.6"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "338.35 96.11 333.77 99 333.77 48.63 338.35 46.14 338.35 96.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "333.77 48.63 253.23 2.74 257.47 0.38 338.35 46.14 333.77 48.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "333.77 99 253.23 52.8 253.23 2.74 333.77 48.63 333.77 99"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 180.1,
    cy: 143.24,
    rx: 13.78,
    ry: 7.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M176.65,127.23h6.9a0,0,0,0,1,0,0v14.44a3.45,3.45,0,0,1-3.45,3.45h0a3.45,3.45,0,0,1-3.45-3.45V127.23a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 180.1,
    cy: 93.79,
    r: 35.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M919.43,382.21a34.76,34.76,0,0,1-26.37-57.39,34.76,34.76,0,1,0,32,56.93A35,35,0,0,1,919.43,382.21Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M982.59,353.14h-20v20c0,.06,0,.12,0,.17s0,.08,0,.11c0,3.48,4.47,6.3,10,6.3s10-2.82,10-6.3c0-.07,0-.15,0-.22s0-.23,0-.35Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 254,
    cy: 82.84,
    rx: 11.27,
    ry: 6.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M983.89,348.1",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M972.61,343.92",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M972.61,354.4c-5.58,0-10.2-2.27-11.1-5.24a3.79,3.79,0,0,0-.17,1.06c0,3.47,5,6.29,11.27,6.29s11.28-2.82,11.28-6.29a3.79,3.79,0,0,0-.17-1.06C982.82,352.13,978.19,354.4,972.61,354.4Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 254,
    cy: 82.84,
    rx: 3,
    ry: 1.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 248.43,
    y1: 94.67,
    x2: 248.43,
    y2: 108.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 259.38,
    y1: 94.67,
    x2: 259.38,
    y2: 108.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 254,
    y1: 96.77,
    x2: 254,
    y2: 111.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M914.86,567.82h-20v20c0,.06,0,.12,0,.18s0,.07,0,.11c0,3.47,4.47,6.29,10,6.29s10-2.82,10-6.29c0-.08,0-.15,0-.22s0-.24,0-.36Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 186.26,
    cy: 297.51,
    rx: 11.27,
    ry: 6.29
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M916.15,562.78",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M904.88,558.6",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M904.88,569.07c-5.58,0-10.2-2.26-11.1-5.23a3.4,3.4,0,0,0-.18,1c0,3.48,5,6.3,11.28,6.3s11.27-2.82,11.27-6.3a3.39,3.39,0,0,0-.17-1C915.08,566.81,910.46,569.07,904.88,569.07Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 186.26,
    cy: 297.51,
    rx: 3,
    ry: 1.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 180.69,
    y1: 309.35,
    x2: 180.69,
    y2: 323.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 191.64,
    y1: 309.35,
    x2: 191.64,
    y2: 323.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 186.26,
    y1: 311.45,
    x2: 186.26,
    y2: 325.73
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1015.7,432.22a14.59,14.59,0,0,0-13.23,0c-3.65,2.12-3.62,5.55,0,7.67a14.61,14.61,0,0,0,13.24,0c3.64-2.12,3.61-5.55,0-7.67",
    transform: "translate(-718.62 -265.26)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1007.17,433.41c2.1-.44,4.05-1.34,4.15.33.06,1.17-2,2.61-4.9,3.52s-2.18-2.82-1.58-3.64C1005.14,433.21,1007.17,433.41,1007.17,433.41Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1010.16,434.62c2.1-.45,4.05-1.35,4.14.33.07,1.16-2,2.6-4.89,3.51s-2.18-2.82-1.58-3.64C1008.12,434.41,1010.16,434.62,1010.16,434.62Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1016.15,415.26c.88,1.14,7.69.68,5.09-.76a3.91,3.91,0,0,0-2.89-.23c.54-.23,1-.08,1-.28s-1.54-.08-1.74.05a1.9,1.9,0,0,1-.39.17,3,3,0,0,0-1-.74c-.38-.06-1,.19-.77.74A3.8,3.8,0,0,0,1016.15,415.26Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1003.93,411.2a8.36,8.36,0,0,1-1.91-3.81c-.1-1.08,0-5.74.52-6.42s1.63-1.68,4.68-1.34a5.89,5.89,0,0,1,1.17.22,5.3,5.3,0,0,1,1.65.66c.38.31,1.21,8.22,1.21,8.22",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1005.09,399.6c0,.75.53,1.21,1.93,1.21s1.64-.42,1.94-.69V399s-.33-1.83-1.67-1.89S1005.09,398,1005.09,399.6Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1013.1,392.73a4.92,4.92,0,1,0-3.29,6.12A4.93,4.93,0,0,0,1013.1,392.73Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1011.11,396.62a2.29,2.29,0,0,0,.08-2.17,1.79,1.79,0,0,0,1.11-.86,1.82,1.82,0,0,0,.07-1.71,2,2,0,0,0,.39-.47,1.86,1.86,0,0,0-.69-2.54,1.79,1.79,0,0,0-.92-.25,1.28,1.28,0,0,0-1.88-1.1,1.83,1.83,0,0,0-.72-.79,1.78,1.78,0,0,0-2.43.65.14.14,0,1,1-.27-.06,1.22,1.22,0,0,0-1.67.45,1.14,1.14,0,0,0-.15.72,1.84,1.84,0,0,0-1.57,2.65,2.13,2.13,0,0,0-1.62,1.06,2.17,2.17,0,0,0,.79,3l.08,0a1.27,1.27,0,0,0-.13.19,1.45,1.45,0,0,0,1.36,2.18,2.56,2.56,0,0,0,4.29,1.33l.09,0a1.44,1.44,0,0,0,2-.53,1.37,1.37,0,0,0,.2-.67A2.31,2.31,0,0,0,1011.11,396.62Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1004.47,430.2c0,1.06.21,3.1.33,4.06s2.19.92,2.27-.13.21-3,.26-3.93S1004.73,429.44,1004.47,430.2Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1007.53,431.06c.05,1.07.21,3.11.33,4.06s2.19.93,2.27-.13.21-3,.26-3.93S1007.79,430.31,1007.53,431.06Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1006.78,418s.73,5.28.75,6.26-.08,4.92-.18,6-2.43,1.43-2.85,0a12.76,12.76,0,0,1,0-6,34.77,34.77,0,0,1-1.33-10.08,28.23,28.23,0,0,1,5.44-.32",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1006.75,417.84s.83,5.13.78,6.45-.09,4.34-.22,6.2,3.12,1.36,3.26.26,1.47-13.48,1.15-16.19a16.33,16.33,0,0,0-4.55-.74",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1004.24,403.32c.36,2.68-.44,8.49-1.17,10s1.43,2.58,4.2,2.58,4.74-.61,4.48-1.85a48.78,48.78,0,0,1-.53-7",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1009,405.62a51.52,51.52,0,0,0,2,4.86,67.09,67.09,0,0,0,4.8,5.26c.67.69,2-1.2,1.43-1.92s-2.75-3.86-3.63-4.87c-.36-1.32-.53-3.42-1.15-5.63a4.51,4.51,0,0,0-3.37-3.26",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1043.53,423.57a14.61,14.61,0,0,0-13.24,0c-3.64,2.12-3.62,5.55,0,7.67a14.59,14.59,0,0,0,13.23,0c3.65-2.12,3.62-5.55,0-7.67",
    transform: "translate(-718.62 -265.26)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1033.92,424.17c-1.35.85-2.36,2-2.1,3.24s2.14.47,2.86.11,3.61-1.73,3.54-2.46,0-1.82-1-1.69A28.3,28.3,0,0,0,1033.92,424.17Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1038.37,426c-1.35.85-2.5,3.59-1.57,4.4s3.14-.71,3.76-1.23a3.39,3.39,0,0,0,1.46-2.38c-.08-.73,0-1.82-1-1.69A10.58,10.58,0,0,0,1038.37,426Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1037.65,401.05c-2.13,0-4,.12-4,.12a23.68,23.68,0,0,0-.42,6.34V424c0,1.52,4.7,1.38,4.7,0V406.18",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1037.67,406.19v19.14c0,1.25,4.86,2.06,4.86.49s.86-16.14,1.35-17.68a18.58,18.58,0,0,0,.39-6.54c-.18-.5-3.33-.59-6.15-.56",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1032.89,390.14c.2,2,.32,11.73,0,12.71,3,1.91,8.62,1.91,11.39-.77.23-4.32-.21-11.12-.82-11.94S1032.89,390.14,1032.89,390.14Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1045.13,404.2c.2-.73.89-4.73,1-5.5a5,5,0,0,0,0-2.12,18.39,18.39,0,0,0-.77-4.72c-.25-.92-4.38.22-4,1.72a26.19,26.19,0,0,0,1.44,3.41,47.52,47.52,0,0,1,.25,6.19c0,.91-1.39,1.57-1.39,1.57l.48,3.72a11.35,11.35,0,0,0,2.11-2.48A9.14,9.14,0,0,0,1045.13,404.2Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1020.64,389.93c.68.38,6.24,3.28,7,3.66a1.91,1.91,0,0,0,1.6.14,8.72,8.72,0,0,0,2.53-.86c.88-.55,1.45-1,1.47-1.23s-.5-3.69-1.77-3.68c-1.16,1-2.41,2.12-2.66,2.28s-.57-.05-.89-.15c-1.53-.46-5.59-1.62-6.33-1.89a7.74,7.74,0,0,0-1.12-2.39c-.42-.66-2.6-1.94-2.77-1s1.15,2.09,1.2,2.63-.8.4-1.51.15-.7.38-.3.65S1019.5,390,1020.64,389.93Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1033.27,392a7.44,7.44,0,0,0-1.47.85c-1.46-.89-1.46-2.52-1.46-3.87,1.09-1.49,2.57-4.2,7-3.7,3.6.41,6.71.73,8.12,6.56-.65,1.83-2.32,2.68-3.87,1.95a7.74,7.74,0,0,1-.69-2.24",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1039.25,385.46c-.17.41-2.41,3.22-2.9,3.22s-.92-1.94-1-2.71V383.3c0-.61,3.94-.49,3.94-.49Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 318.17,
    cy: 114.24,
    r: 4.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1037.29,380.86V382c0,.25-.29.39-.66.14s-1.13-.83-1.46-1.07a.76.76,0,0,1-.31-.75c0-.27,0-.34,0-.84s.25-.36.48-.21,1.38,1,1.59,1.1S1037.29,380.62,1037.29,380.86Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1034.1,378.77v1.16c0,.25-.29.39-.67.14s-1.12-.83-1.45-1.07a.75.75,0,0,1-.31-.74c0-.27,0-.35,0-.84s.24-.37.48-.21,1.38,1,1.59,1.1S1034.1,378.53,1034.1,378.77Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 316.24,
    y1: 114.24,
    x2: 315.48,
    y2: 113.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1041,380.42c.31-1.5.07-2.5-1.85-2.37-2.32.16-5.53-1.36-4.63-3,.47-.83,1.69-1.3,3.4-1.3a5.45,5.45,0,0,1,3.61,1.51c1.27,1.37,1.15,3.35.83,4.91C1041.49,384.26,1041,380.42,1041,380.42Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 318.4,
    y1: 114.23,
    x2: 317.56,
    y2: 113.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 315.48,
    y1: 112.54,
    x2: 314.65,
    y2: 112.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1034.57,381.69c-.16-.07-.52-.22-.57-.37",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1035.66,382.73a2.45,2.45,0,0,1-1-.26",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1040.43,380.52a1.13,1.13,0,0,1,.81,0,1.37,1.37,0,0,1-.86,2.59,1.12,1.12,0,0,1-.72-.72",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 318.67,
    y1: 115.88,
    x2: 322.4,
    y2: 114.83
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M970.46,391s-22.55,37.09-22.55,58.36c0,12.91,10.09,23.37,22.55,23.37S993,462.29,993,449.38C993,428.13,970.46,391,970.46,391Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M983,465.1c-12.24,0-22.17-10.33-22.17-23.06,0-12.34,7.66-30.06,14-42.58-2.59-4.77-4.41-7.77-4.41-7.77s-22.16,36.6-22.16,57.59c0,12.74,9.92,23.06,22.16,23.06a21.76,21.76,0,0,0,16.45-7.59A21.18,21.18,0,0,1,983,465.1Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 251.84,
    cy: 229.33,
    rx: 14.48,
    ry: 8.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M247.85,207.21h8a0,0,0,0,1,0,0V226.8a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4V207.21a0,0,0,0,1,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M760.54,393S738,430.12,738,451.39c0,12.91,10.09,23.37,22.55,23.37s22.55-10.46,22.55-23.37C783.09,430.14,760.54,393,760.54,393Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M773.05,467.11c-12.24,0-22.17-10.33-22.17-23.06,0-12.34,7.66-30.06,14-42.58-2.59-4.77-4.4-7.77-4.4-7.77s-22.17,36.6-22.17,57.59c0,12.74,9.92,23.06,22.17,23.06a21.75,21.75,0,0,0,16.44-7.59A22.11,22.11,0,0,1,773.05,467.11Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 41.92,
    cy: 231.33,
    rx: 14.48,
    ry: 8.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M37.93,209.22h8a0,0,0,0,1,0,0V228.8a4,4,0,0,1-4,4h0a4,4,0,0,1-4-4V209.22A0,0,0,0,1,37.93,209.22Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M963.1,609.16c0-1.06-.89-2-2.24-2.59h0l-29.17-15.68h0a8,8,0,0,0-3.59-.79c-3,0-5.45,1.43-5.5,3.19v7.23h0a3.13,3.13,0,0,0,2,2.42h0l29,15.6a7.78,7.78,0,0,0,3.9,1c2.93,0,5.32-1.36,5.48-3.06a.13.13,0,0,0,0-.06v-7.21Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M960.91,606.73h0L931.76,591h0a8.07,8.07,0,0,0-3.6-.79c-3,0-5.5,1.45-5.5,3.24a3.05,3.05,0,0,0,2.06,2.52h0l29,15.61a7.81,7.81,0,0,0,3.9,1c3,0,5.5-1.46,5.5-3.25C963.15,608.26,962.26,607.32,960.91,606.73Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 214.35,
    cy: 324.1,
    r: 8.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 226.18,
    cy: 330.04,
    r: 8.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 236.5,
    cy: 335.35,
    r: 8.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M839.27,441h-7.43v7.44s0,0,0,.06,0,0,0,0c0,1.3,1.67,2.34,3.72,2.34s3.71-1,3.71-2.34c0,0,0-.05,0-.08s0-.09,0-.13Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 116.94,
    cy: 139.77,
    r: 6.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 116.94,
    cy: 132.71,
    r: 2.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M833.48,441.19l-.14-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M838.31,440.92l0,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M833.15,441.07l-.11,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M835.56,441.5l-.41,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M839.36,440.14h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M837.77,441.14l-.14.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M833.83,441.29l-.17-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M832.85,440.94l-.05,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M835,441.47l-.26,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M834.2,441.37l-.19,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M838.07,441l-.11,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M834.59,441.43l-.22,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M837.11,441.33l-.2,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M831.76,440.14h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M836.74,441.4l-.22,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M839.61,439.75h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M837.45,441.24l-.17.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M836,441.48l-.4,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M831.62,440h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M839.5,439.94v0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M831.51,439.76h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M836.36,441.45l-.26,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M831.5,439.75h0l.1.19h0a1.27,1.27,0,0,0,.13.19h0a3.3,3.3,0,0,0,1,.78l.05,0,.19.09.11,0,.19.07.14.05.18.05.17.05.18,0,.19,0,.17,0,.22,0,.16,0,.26,0h.14l.41,0,.4,0h.14l.26,0,.16,0,.22,0,.17,0,.2,0,.17,0,.17-.05.18-.05.14-.05.19-.07.11,0,.2-.09,0,0a3.19,3.19,0,0,0,1-.78h0l.13-.18v0a1.62,1.62,0,0,0,.1-.18h0a1.59,1.59,0,0,0,.07-.2,1.34,1.34,0,0,0,.07-.39c0-1.3-1.88-2.34-4.19-2.34s-4.2,1-4.2,2.34a1.34,1.34,0,0,0,.07.39h0A1.59,1.59,0,0,0,831.5,439.75Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M839.68,439.55h0a1.59,1.59,0,0,1-.07.2h0a1.62,1.62,0,0,1-.1.18v0l-.13.18h0a3.19,3.19,0,0,1-1,.78l0,0-.2.09-.11,0-.19.07-.14.05-.18.05-.17.05-.17,0-.2,0-.17,0-.22,0-.16,0-.26,0H836l-.4,0-.41,0H835l-.26,0-.16,0-.22,0-.17,0-.19,0-.18,0-.17-.05-.18-.05-.14-.05-.19-.07-.11,0-.19-.09-.05,0a3.19,3.19,0,0,1-1-.78h0a1.27,1.27,0,0,1-.13-.19h0l-.1-.19h0a1.59,1.59,0,0,1-.07-.2,1.34,1.34,0,0,0-.07.39c0,1.29,1.88,2.34,4.2,2.34s4.19-1,4.19-2.34A1.34,1.34,0,0,0,839.68,439.55Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M838.27,440.94l-.2.09Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M839.68,439.55a1.59,1.59,0,0,1-.07.2A1.59,1.59,0,0,0,839.68,439.55Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M837.28,441.29l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M838,441.07l-.19.07Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M839.49,440l-.13.18Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M839.6,439.76a1.62,1.62,0,0,1-.1.18A1.62,1.62,0,0,0,839.6,439.76Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M837.63,441.19l-.18.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M835.15,441.48h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M831.75,440.14a1.27,1.27,0,0,1-.13-.19A1.27,1.27,0,0,0,831.75,440.14Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M833,441l-.19-.09Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M831.61,440l-.1-.19Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M831.43,439.55h0a1.59,1.59,0,0,0,.07.2A1.59,1.59,0,0,1,831.43,439.55Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M833.34,441.14l-.19-.07Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M836.91,441.37l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M831.76,440.14a3.19,3.19,0,0,0,1,.78A3.3,3.3,0,0,1,831.76,440.14Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M838.31,440.92a3.19,3.19,0,0,0,1-.78A3.19,3.19,0,0,1,838.31,440.92Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M833.66,441.24l-.18-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M836.52,441.43l-.16,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M834.75,441.45l-.16,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M836.1,441.47h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M834.37,441.4l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M834,441.33l-.18,0Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M115.37,145.89h3.12a0,0,0,0,1,0,0V173a1.56,1.56,0,0,1-1.56,1.56h0a1.56,1.56,0,0,1-1.56-1.56V145.89A0,0,0,0,1,115.37,145.89Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M884.91,414.88h-7.42v7.54c0,1.29,1.66,2.34,3.71,2.34s3.71-1.05,3.71-2.34c0,0,0-.05,0-.08a.57.57,0,0,0,0-.13Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.58,
    cy: 113.62,
    r: 6.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.58,
    cy: 106.56,
    r: 2.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M879.12,415l-.14,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M884,414.76l0,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M878.79,414.92l-.1-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M881.2,415.34h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M885,414h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M883.42,415l-.15,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M879.47,415.13l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M878.49,414.79l0,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M880.66,415.32l-.26,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M879.84,415.22l-.19,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M883.71,414.87l-.11.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M880.23,415.28l-.22,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M882.75,415.18l-.2,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M877.4,414h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M882.38,415.25l-.22,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M885.25,413.59h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M883.09,415.09l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M881.61,415.33h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M877.26,413.8h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M885.14,413.79h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M877.15,413.6h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M882,415.3l-.26,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M877.15,413.59h0a1.18,1.18,0,0,0,.11.19h0l.14.18h0a3.08,3.08,0,0,0,1.05.77l0,0,.2.08.1.05.19.07.14,0,.18.06.17,0,.18.05.19,0,.17,0,.22,0,.17,0,.26,0h1.08l.26,0,.16,0,.22,0,.17,0,.2,0,.17-.05.17,0,.18-.06.15,0,.18-.07.11-.05.2-.08,0,0a3.08,3.08,0,0,0,1-.77h0l.13-.18h0a1.18,1.18,0,0,0,.11-.19h0a1.54,1.54,0,0,0,.08-.19,1.34,1.34,0,0,0,.06-.4c0-1.29-1.88-2.34-4.19-2.34s-4.19,1-4.19,2.34a1.34,1.34,0,0,0,.06.4h0A1.54,1.54,0,0,0,877.15,413.59Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M885.33,413.4h0a1.54,1.54,0,0,1-.08.19h0a1.18,1.18,0,0,1-.11.19h0L885,414h0a3.08,3.08,0,0,1-1,.77l0,0-.2.08-.11.05-.18.07-.15,0-.18.06-.17,0-.17.05-.2,0-.17,0-.22,0-.16,0-.26,0h-1.08l-.26,0-.17,0-.22,0-.17,0-.19,0-.18-.05-.17,0-.18-.06-.14,0-.19-.07-.1-.05-.2-.08,0,0a3.08,3.08,0,0,1-1.05-.77h0l-.14-.18h0a1.18,1.18,0,0,1-.11-.19h0a1.54,1.54,0,0,1-.08-.19,1.23,1.23,0,0,0-.06.39c0,1.29,1.87,2.34,4.19,2.34s4.19-1.05,4.19-2.34A1.23,1.23,0,0,0,885.33,413.4Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M883.91,414.79l-.2.08Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M885.33,413.4a1.54,1.54,0,0,1-.08.19A1.54,1.54,0,0,0,885.33,413.4Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M882.92,415.13l-.17.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M883.6,414.92l-.18.07Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M885.13,413.8,885,414Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M885.25,413.6a1.18,1.18,0,0,1-.11.19A1.18,1.18,0,0,0,885.25,413.6Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M883.27,415l-.18.06Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M880.79,415.33h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M877.4,414l-.14-.18Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M878.69,414.87l-.2-.08Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M877.26,413.79a1.18,1.18,0,0,1-.11-.19A1.18,1.18,0,0,0,877.26,413.79Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M877.07,413.4h0a1.54,1.54,0,0,0,.08.19A1.54,1.54,0,0,1,877.07,413.4Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M879,415l-.19-.07Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M882.55,415.22l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M877.4,414a3.08,3.08,0,0,0,1.05.77A3.08,3.08,0,0,1,877.4,414Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M884,414.76a3.08,3.08,0,0,0,1-.77A3.08,3.08,0,0,1,884,414.76Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M879.3,415.09l-.18-.06Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M882.16,415.28l-.16,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M880.4,415.3l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M881.74,415.32h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M880,415.25l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M879.65,415.18l-.18-.05Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161,119.74h3.12a0,0,0,0,1,0,0V146.8a1.56,1.56,0,0,1-1.56,1.56h0A1.56,1.56,0,0,1,161,146.8V119.74A0,0,0,0,1,161,119.74Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M834.89,544.5h-7.42v7.55c0,1.29,1.66,2.34,3.71,2.34s3.71-1,3.71-2.34V544.5Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 112.56,
    cy: 243.25,
    r: 6.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 112.56,
    cy: 236.18,
    r: 2.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M829.11,544.66l-.15,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M833.94,544.39l-.05,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M828.78,544.54l-.11,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M831.18,545h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M835,543.61Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M833.4,544.61l-.14,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M829.46,544.76l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M828.47,544.41l0,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M830.64,544.94l-.26,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M829.83,544.84l-.2,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M833.69,544.5l-.1,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M830.22,544.9l-.22,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M832.73,544.8l-.19,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M827.38,543.61Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M832.37,544.87l-.22,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M835.23,543.22h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M833.08,544.71l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M831.59,545h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M827.25,543.43h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M835.13,543.42h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M827.13,543.23h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M832,544.92l-.26,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M827.13,543.22h0l.11.19h0l.13.18h0a3.23,3.23,0,0,0,1,.78l0,0,.2.09.11,0,.18.07.15,0,.18.05.17,0,.17,0,.2,0,.17,0,.22,0,.16,0,.26,0,.13,0h.82l.14,0,.26,0,.16,0,.22,0,.17,0,.19,0,.18,0,.17,0,.18-.05.14,0,.19-.07.1,0,.2-.09.05,0a3.3,3.3,0,0,0,1-.78h0l.14-.18h0c0-.07.07-.13.1-.19h0a1.67,1.67,0,0,0,.08-.2,1.34,1.34,0,0,0,.07-.39c0-1.3-1.88-2.34-4.2-2.34s-4.19,1-4.19,2.34a1.32,1.32,0,0,0,.06.39h0A1.67,1.67,0,0,0,827.13,543.22Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M835.31,543h0a.84.84,0,0,1-.08.2h0c0,.06-.07.12-.1.19h0l-.14.18h0a3.3,3.3,0,0,1-1,.78l-.05,0-.2.09-.1,0-.19.07-.14,0-.18.05-.17,0-.18,0-.19,0-.17,0-.22,0-.16,0-.26,0-.14,0h-.82l-.13,0-.26,0-.16,0-.22,0-.17,0-.2,0-.17,0-.17,0-.18-.05-.15,0-.18-.07-.11,0-.2-.09,0,0a3.23,3.23,0,0,1-1-.78h0l-.13-.18h0l-.11-.19h0a1.67,1.67,0,0,1-.08-.2,1.32,1.32,0,0,0-.06.39c0,1.29,1.88,2.34,4.19,2.34s4.2-1,4.2-2.34A1.34,1.34,0,0,0,835.31,543Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M833.89,544.41l-.2.09Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M835.31,543a1.67,1.67,0,0,1-.08.2A.84.84,0,0,0,835.31,543Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M832.91,544.76l-.18,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M833.59,544.54l-.19.07Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M835.12,543.43l-.14.18Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M835.23,543.23c0,.06-.07.12-.1.19S835.2,543.29,835.23,543.23Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M833.26,544.66l-.18.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M830.77,545l-.13,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M827.38,543.61l-.13-.18Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M828.67,544.5l-.2-.09Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M827.24,543.42l-.11-.19Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M827.05,543h0a1.67,1.67,0,0,0,.08.2A1.67,1.67,0,0,1,827.05,543Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M829,544.61l-.18-.07Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M832.54,544.84l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M827.38,543.61a3.23,3.23,0,0,0,1,.78A3.23,3.23,0,0,1,827.38,543.61Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M833.94,544.39a3.3,3.3,0,0,0,1-.78A3.3,3.3,0,0,1,833.94,544.39Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M829.29,544.71l-.18-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M832.15,544.9l-.16,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M830.38,544.92l-.16,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M831.73,544.94l-.14,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M830,544.87l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M829.63,544.8l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111,249.36h3.12a0,0,0,0,1,0,0v27.06a1.56,1.56,0,0,1-1.56,1.56h0a1.56,1.56,0,0,1-1.56-1.56V249.36a0,0,0,0,1,0,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1066.93,569.56h-7.42v7.54c0,1.3,1.66,2.34,3.71,2.34s3.71-1,3.71-2.34a.22.22,0,0,0,0-.08.57.57,0,0,0,0-.13Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 344.6,
    cy: 268.3,
    r: 6.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 344.6,
    cy: 261.24,
    r: 2.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1061.14,569.72l-.14-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1066,569.45l0,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1060.82,569.6l-.11-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1063.22,570h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1067,568.66h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1065.44,569.67l-.15.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1061.49,569.82l-.17-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1060.51,569.47l0,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1062.68,570l-.26,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1061.86,569.9l-.19,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1065.73,569.55l-.11.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1062.26,570l-.23,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1064.77,569.86l-.2,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1059.42,568.67h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1064.4,569.93l-.22,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1067.27,568.28Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1065.12,569.77l-.18.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1063.63,570h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1059.28,568.48h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1067.16,568.47h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1059.17,568.28Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1064,570l-.26,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1059.17,568.28h0a1.18,1.18,0,0,0,.11.19h0a1.24,1.24,0,0,0,.14.18h0a3.23,3.23,0,0,0,1,.78l0,0,.2.08.11.05.18.07.14.05.18,0,.17.05.18,0,.19,0,.17,0,.23,0,.16,0,.26,0h1.08l.26,0,.16,0,.22,0,.17,0,.2,0,.17,0,.18-.05.17,0,.15-.05.18-.07.11-.05.2-.08,0,0a3.23,3.23,0,0,0,1-.78h0a1.41,1.41,0,0,0,.14-.18h0a1.18,1.18,0,0,0,.11-.19h0l.08-.2a1.34,1.34,0,0,0,.06-.4c0-1.29-1.88-2.34-4.19-2.34s-4.19,1-4.19,2.34a1.34,1.34,0,0,0,.06.4h0C1059.11,568.14,1059.14,568.21,1059.17,568.28Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1067.35,568.08h0l-.08.2h0a1.18,1.18,0,0,1-.11.19h0a1.41,1.41,0,0,1-.14.18h0a3.23,3.23,0,0,1-1,.78l0,0-.2.08-.11.05-.18.07-.15.05-.17,0-.18.05-.17,0-.2,0-.17,0-.22,0-.16,0-.26,0h-1.08l-.26,0-.16,0-.23,0-.17,0-.19,0-.18,0-.17-.05-.18,0-.14-.05-.18-.07-.11-.05-.2-.08,0,0a3.23,3.23,0,0,1-1-.78h0a1.24,1.24,0,0,1-.14-.18h0a1.18,1.18,0,0,1-.11-.19h0c0-.07-.06-.14-.08-.2a1.27,1.27,0,0,0-.06.39c0,1.29,1.87,2.34,4.19,2.34s4.19-1,4.19-2.34A1.27,1.27,0,0,0,1067.35,568.08Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1065.93,569.47l-.2.08Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1067.35,568.08l-.08.2Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1064.94,569.82l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1065.62,569.6l-.18.07Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1067.16,568.48a1.41,1.41,0,0,1-.14.18A1.41,1.41,0,0,0,1067.16,568.48Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1067.27,568.28a1.18,1.18,0,0,1-.11.19A1.18,1.18,0,0,0,1067.27,568.28Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1065.29,569.72l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1062.81,570h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1059.42,568.66a1.24,1.24,0,0,1-.14-.18A1.24,1.24,0,0,0,1059.42,568.66Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1060.71,569.55l-.2-.08Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1059.28,568.47a1.18,1.18,0,0,1-.11-.19A1.18,1.18,0,0,0,1059.28,568.47Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1059.09,568.08h0c0,.06.05.13.08.2S1059.11,568.14,1059.09,568.08Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1061,569.67l-.18-.07Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1064.57,569.9l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1059.42,568.67a3.23,3.23,0,0,0,1,.78A3.23,3.23,0,0,1,1059.42,568.67Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1066,569.45a3.23,3.23,0,0,0,1-.78A3.23,3.23,0,0,1,1066,569.45Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1061.32,569.77l-.18,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1064.18,570l-.16,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1062.42,570l-.16,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1063.76,570h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1062,569.93l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1061.67,569.86l-.18,0Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M343,274.42h3.12a0,0,0,0,1,0,0v27.06A1.56,1.56,0,0,1,344.6,303h0a1.56,1.56,0,0,1-1.56-1.56V274.42A0,0,0,0,1,343,274.42Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M882.63,572.19h-7.42v7.55c0,1.29,1.66,2.34,3.71,2.34s3.71-1.05,3.71-2.34c0,0,0-.06,0-.08s0-.09,0-.14Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.3,
    cy: 270.94,
    r: 6.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 160.3,
    cy: 263.87,
    r: 2.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M876.84,572.35l-.14-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M881.67,572.08l0,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M876.51,572.24l-.1,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M878.92,572.66h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M882.72,571.3h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M881.14,572.3l-.15.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M877.19,572.45l-.17-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M876.21,572.1l-.05,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M878.37,572.64l-.26,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M877.56,572.53l-.19,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M881.43,572.19l-.11,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M878,572.6l-.22,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M880.47,572.49l-.2,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M875.12,571.31h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M880.1,572.56l-.22,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M883,570.91h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M880.81,572.4l-.17.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M879.32,572.65h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M875,571.12h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M882.86,571.11h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M874.87,570.92h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M879.72,572.62l-.26,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M874.87,570.91h0a1.74,1.74,0,0,0,.1.19h0l.13.18h0a3.28,3.28,0,0,0,1,.77l.05,0,.2.09.1,0,.19.06.14.05.18,0,.17.05.18,0,.19,0,.17,0,.22,0,.16,0,.26,0h1.09l.26,0,.16,0,.22,0,.17,0,.2,0,.17,0,.17-.05.18,0,.15-.05.18-.06.11,0,.2-.09,0,0a3.07,3.07,0,0,0,1-.77h0l.13-.18h0a1.74,1.74,0,0,0,.1-.19h0a1.19,1.19,0,0,0,.08-.2,1.76,1.76,0,0,0,.06-.39c0-1.29-1.88-2.34-4.19-2.34s-4.2,1-4.2,2.34a1.34,1.34,0,0,0,.07.39h0A.7.7,0,0,0,874.87,570.91Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M883.05,570.71h0a1.19,1.19,0,0,1-.08.2h0a1.74,1.74,0,0,1-.1.19h0l-.13.18h0a3.07,3.07,0,0,1-1,.77l0,0-.2.09-.11,0-.18.06-.15.05-.18,0-.17.05-.17,0-.2,0-.17,0-.22,0-.16,0-.26,0h-1.09l-.26,0-.16,0-.22,0-.17,0-.19,0-.18,0-.17-.05-.18,0-.14-.05-.19-.06-.1,0-.2-.09-.05,0a3.28,3.28,0,0,1-1-.77h0l-.13-.18h0a1.74,1.74,0,0,1-.1-.19h0a.7.7,0,0,1-.08-.2,1.34,1.34,0,0,0-.07.4c0,1.29,1.88,2.34,4.2,2.34s4.19-1.05,4.19-2.34A1.76,1.76,0,0,0,883.05,570.71Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M881.63,572.1l-.2.09Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M883.05,570.71a1.19,1.19,0,0,1-.08.2A1.19,1.19,0,0,0,883.05,570.71Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M880.64,572.45l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M881.32,572.24l-.18.06Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M882.85,571.12l-.13.18Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M883,570.92a1.74,1.74,0,0,1-.1.19A1.74,1.74,0,0,0,883,570.92Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M881,572.35l-.18,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M878.51,572.65h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M875.11,571.3l-.13-.18Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M876.41,572.19l-.2-.09Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M875,571.11a1.74,1.74,0,0,1-.1-.19A1.74,1.74,0,0,0,875,571.11Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M874.79,570.71h0a.7.7,0,0,0,.08.2A.7.7,0,0,1,874.79,570.71Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M876.7,572.3l-.19-.06Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M880.27,572.53l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M875.12,571.31a3.28,3.28,0,0,0,1,.77A3.28,3.28,0,0,1,875.12,571.31Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M881.67,572.08a3.07,3.07,0,0,0,1-.77A3.07,3.07,0,0,1,881.67,572.08Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M877,572.4l-.18,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M879.88,572.6l-.16,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M878.11,572.62l-.16,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M879.46,572.64h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M877.73,572.56l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M877.37,572.49l-.18,0Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.74,277.05h3.12a0,0,0,0,1,0,0v27.06a1.56,1.56,0,0,1-1.56,1.56h0a1.56,1.56,0,0,1-1.56-1.56V277.05A0,0,0,0,1,158.74,277.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1062.41,410.65H1055v7.54c0,1.29,1.66,2.34,3.71,2.34s3.71-1,3.71-2.34v-7.54Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 340.08,
    cy: 109.39,
    r: 6.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 340.08,
    cy: 102.33,
    r: 2.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1056.63,410.81l-.15-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1061.46,410.54l0,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1056.3,410.69l-.11-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1058.7,411.11h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1062.5,409.75h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1060.92,410.76l-.14.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1057,410.9l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1056,410.56l0,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1058.16,411.09l-.26,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1057.35,411l-.2,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1061.21,410.64l-.1.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1057.74,411.05l-.22,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1060.25,411l-.19,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1054.9,409.76h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1059.89,411l-.22,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1062.75,409.36h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1060.6,410.86l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1059.11,411.1h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1054.77,409.57h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1062.64,409.56h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1054.65,409.37Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1059.51,411.07l-.27,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1054.65,409.37h0a1.18,1.18,0,0,0,.11.19h0a1.18,1.18,0,0,0,.13.18h0a3.23,3.23,0,0,0,1,.78l0,0,.2.08.11.05.18.07.15.05.18.05.17,0,.17.05.2,0,.17,0,.22,0,.16,0,.26,0h1.08l.27,0,.16,0,.22,0,.17,0,.19,0,.18-.05.17,0,.18-.05.14-.05.19-.07.1-.05.2-.08,0,0a3.3,3.3,0,0,0,1-.78h0a1.24,1.24,0,0,0,.14-.18h0a1.18,1.18,0,0,0,.11-.19h0a1.54,1.54,0,0,0,.08-.19,1.34,1.34,0,0,0,.06-.4c0-1.29-1.87-2.34-4.19-2.34s-4.19,1.05-4.19,2.34a1.34,1.34,0,0,0,.06.4h0C1054.59,409.23,1054.62,409.3,1054.65,409.37Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1062.83,409.17h0a1.54,1.54,0,0,1-.08.19h0a1.18,1.18,0,0,1-.11.19h0a1.24,1.24,0,0,1-.14.18h0a3.3,3.3,0,0,1-1,.78l0,0-.2.08-.1.05-.19.07-.14.05-.18.05-.17,0-.18.05-.19,0-.17,0-.22,0-.16,0-.27,0h-1.08l-.26,0-.16,0-.22,0-.17,0-.2,0-.17-.05-.17,0-.18-.05-.15-.05-.18-.07-.11-.05-.2-.08,0,0a3.23,3.23,0,0,1-1-.78h0a1.18,1.18,0,0,1-.13-.18h0a1.18,1.18,0,0,1-.11-.19h0c0-.07-.06-.14-.08-.2a1.27,1.27,0,0,0-.06.39c0,1.29,1.88,2.34,4.19,2.34s4.19-1,4.19-2.34A1.27,1.27,0,0,0,1062.83,409.17Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1061.41,410.56l-.2.08Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1062.83,409.17a1.54,1.54,0,0,1-.08.19A1.54,1.54,0,0,0,1062.83,409.17Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1060.43,410.9l-.18.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1061.11,410.69l-.19.07Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1062.64,409.57a1.24,1.24,0,0,1-.14.18A1.24,1.24,0,0,0,1062.64,409.57Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1062.75,409.37a1.18,1.18,0,0,1-.11.19A1.18,1.18,0,0,0,1062.75,409.37Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1060.78,410.81l-.18.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1058.29,411.1h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1054.9,409.75a1.18,1.18,0,0,1-.13-.18A1.18,1.18,0,0,0,1054.9,409.75Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1056.19,410.64l-.2-.08Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1054.76,409.56a1.18,1.18,0,0,1-.11-.19A1.18,1.18,0,0,0,1054.76,409.56Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1054.57,409.17h0c0,.06,0,.13.08.2S1054.59,409.23,1054.57,409.17Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1056.48,410.76l-.18-.07Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1060.06,411l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1054.9,409.76a3.23,3.23,0,0,0,1,.78A3.23,3.23,0,0,1,1054.9,409.76Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1061.46,410.54a3.3,3.3,0,0,0,1-.78A3.3,3.3,0,0,1,1061.46,410.54Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1056.81,410.86l-.18-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1059.67,411.05l-.16,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1057.9,411.07l-.16,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1059.24,411.09h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1057.52,411l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1057.15,411l-.17-.05Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M338.52,115.51h3.12a0,0,0,0,1,0,0v27.06a1.56,1.56,0,0,1-1.56,1.56h0a1.56,1.56,0,0,1-1.56-1.56V115.51A0,0,0,0,1,338.52,115.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1110.15,438.34h-7.42v7.55c0,1.29,1.66,2.34,3.71,2.34s3.71-1.05,3.71-2.34c0,0,0-.06,0-.09s0-.08,0-.13Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 387.82,
    cy: 137.09,
    r: 6.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 387.82,
    cy: 130.02,
    r: 2.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1104.36,438.5l-.14-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1109.19,438.23l0,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1104,438.38l-.11,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1106.44,438.81h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1110.24,437.45h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1108.65,438.45l-.14.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1104.71,438.6l-.17-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1103.73,438.25l0,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1105.89,438.79l-.26,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1105.08,438.68l-.19,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1109,438.34l-.11,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1105.47,438.74l-.22,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1108,438.64l-.2,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1102.64,437.45h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1107.62,438.71l-.22,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1110.49,437.06h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1108.33,438.55l-.17.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1106.84,438.8h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1102.5,437.27h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1110.38,437.26h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1102.39,437.07h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1107.24,438.76l-.26,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1102.38,437.06h0l.1.19h0l.13.18h0a3.16,3.16,0,0,0,1,.78l0,0,.19.09.11,0,.19.07.14.05.18.05.17.05.18,0,.19,0,.17,0,.22,0,.16,0,.26,0H1107l.26,0,.16,0,.22,0,.17,0,.2,0,.17,0,.17-.05.18-.05.14-.05.19-.07.11,0,.2-.09,0,0a3.08,3.08,0,0,0,1-.78h0l.13-.18h0l.1-.19h0l.08-.2a1.76,1.76,0,0,0,.06-.39c0-1.3-1.88-2.34-4.19-2.34s-4.2,1-4.2,2.34a1.34,1.34,0,0,0,.07.39h0A1.59,1.59,0,0,0,1102.38,437.06Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1110.57,436.86h0l-.08.2h0l-.1.19h0l-.13.18h0a3.05,3.05,0,0,1-1,.78l0,0-.2.09-.11,0-.19.07-.14.05-.18.05-.17.05-.17,0-.2,0-.17,0-.22,0-.16,0-.26,0h-1.09l-.26,0-.16,0-.22,0-.17,0-.19,0-.18,0-.17-.05-.18-.05-.14-.05-.19-.07-.11,0-.19-.09,0,0a3.05,3.05,0,0,1-1-.78h0l-.13-.18h0l-.1-.19h0a1.59,1.59,0,0,1-.07-.2,1.34,1.34,0,0,0-.07.39c0,1.3,1.88,2.34,4.2,2.34s4.19-1,4.19-2.34A1.76,1.76,0,0,0,1110.57,436.86Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1109.15,438.25l-.2.09Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1110.57,436.86l-.08.2Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1108.16,438.6l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1108.84,438.38l-.19.07Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1110.37,437.27l-.13.18Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1110.48,437.07l-.1.19Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1108.51,438.5l-.18.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1106,438.8h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1102.63,437.45l-.13-.18Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1103.92,438.34l-.19-.09Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1102.49,437.26l-.1-.19Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1102.31,436.86h0a1.59,1.59,0,0,0,.07.2A1.59,1.59,0,0,1,1102.31,436.86Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1104.22,438.45l-.19-.07Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1107.79,438.68l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1102.64,437.45a3.05,3.05,0,0,0,1,.78A3.16,3.16,0,0,1,1102.64,437.45Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1109.19,438.23a3.05,3.05,0,0,0,1-.78A3.08,3.08,0,0,1,1109.19,438.23Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1104.54,438.55l-.18-.05Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1107.4,438.74l-.16,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1105.63,438.76l-.16,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1107,438.79h0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1105.25,438.71l-.17,0Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1104.89,438.64l-.18,0Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M386.26,143.2h3.12a0,0,0,0,1,0,0v27.06a1.56,1.56,0,0,1-1.56,1.56h0a1.56,1.56,0,0,1-1.56-1.56V143.2A0,0,0,0,1,386.26,143.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M908,493.21c-5.32-3.07-13.92-3.06-19.2,0s-5.26,8,.06,11.11,13.92,3.08,19.2,0,5.26-8.06-.06-11.13",
    transform: "translate(-718.62 -265.26)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M907.35,486.27c.57,1.21-.34,3.68.27,4.87.53,1,2.17,1.2,2.61.24a27,27,0,0,0,1-4.37c.22-1.11.59-2.14-.41-2.71s-1.84-1.19-2.39-.5A11.65,11.65,0,0,0,907.35,486.27Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M907.48,490.22a2.26,2.26,0,0,1,3,0",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M894.15,477.61a19.46,19.46,0,0,0,1.32,3.16c.69,1.32,4.74,2.86,5.75,3.24,3.86,1.46,5.3,1.91,6,2.14,1.51.52,2.1-.12,2.36-.79s0-1.12-.88-1.79c-2.48-2-3.5-2.86-4.49-3.29a7.41,7.41,0,0,0-4.33-.81c0-.78-.08-1.19-.08-2.33",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M893,495.49c-.81,1.07-3.63,3.15-4.12,4.33-.6,1.42,1.38,2.13,1.78,1.94s3.77-1.9,4.51-2.29a2,2,0,0,0,1.32-2.06c0-1.15.09-1.89-.78-2.05A11.53,11.53,0,0,0,893,495.49Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M889.86,498.7a2.36,2.36,0,0,1,2.43,2.14",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M894.15,477.61a6.52,6.52,0,0,1-.47,1.37,6.75,6.75,0,0,0-1,2.78c0,4.55.23,10.63.38,12.3.12,1.3-.06,1.95.82,2.34a1.3,1.3,0,0,0,1.91-1c.74-2.88,1.18-6.28,1.4-7.67a10.21,10.21,0,0,0-.44-5.57,14.77,14.77,0,0,0,1.75-2.94",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M878.2,456.79c-.26-.24-.18-.78.22-.78s1.06.59,1.24.79,0,1.33.3,1.52c1,.62,3.82,2.73,4.28,2.05s.33-.77.93-1.79c.36-.63,3.91,1.4,3.46,2.25s-.79,1.5-1.32,2.42-2,.9-2.9.38-5.11-2.69-5.7-3.15c-.27-.21-.73.1-1.54,0s-3-.78-2-3c.56-1.34,1-1.33,1.82-1.29a2.79,2.79,0,0,1,1.46.8",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M894.93,450.7c-10.16.52-8.14,5.9-9.76,7.88-.56.69,2.58,3.59,3.77,1.95a6.34,6.34,0,0,0,1.66-4.26",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M895.2,467.71c-.68,0-1.34-1.59-4.1-1,0,2.09,2.69,9.48,3.24,11.39.47,1.63,5.5.71,5.5-1.33",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M895.19,472.44c-.38,1.6-1.24,5.17-1.63,6.45-.26.82,4.17,2.35,4.81,1.13a38.09,38.09,0,0,0,1.56-3.49c2.83-1.68,2.64-7.47-.22-9.81-1.71-.62-3.92.73-3.92.73",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M896.08,450.75c4.29,2.65,4.17,9.89,3.67,13.21a5.62,5.62,0,0,0,0,2.76c-.61.75-6.2,2.87-8.52.6-.23-1.3-.3-1.57-.66-3.44-.49-2.65-1.43-4.41-1.71-6s-.29-1.87.13-2.7",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M895.93,466c-1.08.89,0,3.15.82,3.2a4.66,4.66,0,0,0,2.79-1c.33-.42.12-.92.35-1.25.71-1,5.06-4.55,5.78-5.77s-1.24-3.87-2.23-5.2c-.65-.86-4.33,1.44-3.24,2.7a7.43,7.43,0,0,1,1.31,1.85c.11.52-3.07,3.86-3.47,4.42-.21.28-.87-.27-1.38-.05s-.93.46-.77.72c.31.51.73.27,1,.15",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M896.6,455.86c.57.15,2,.29,3.35,2.65.6,1,3.35-1,3.49-2.47.08-.85-3.58-5-7.36-5.29",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M895.77,448.9c.12.74.31,1.85.31,1.85s-.07,1-2.15,1.33c-1.74.25-1.74-.53-1.81-1s-.23-1.24-.32-1.77S895.57,447.76,895.77,448.9Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 173.81,
    cy: 179.32,
    r: 5.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 170.09,
    y1: 178.74,
    x2: 170.25,
    y2: 179.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 172.76,
    y1: 179.1,
    x2: 172.93,
    y2: 179.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M890.56,447.75a2.06,2.06,0,0,0,1.45-.33",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M889.55,445.21c-.15.36-.78,1.11.52,1.61",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M887.22,441.75c-.24,1.37,3.28,1.65,5.09,1s2.45-1,3-.82a1.82,1.82,0,0,1,1,1.88c-.13,1.81.88,3.19.6,3.85a6.34,6.34,0,0,0,1.2-6.3,5.15,5.15,0,0,0-5.53-3.43C890.05,438.1,887.58,439.76,887.22,441.75Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M896,444.62a1.2,1.2,0,0,1,.74-.5,1.52,1.52,0,0,1,.65,2.94,1.27,1.27,0,0,1-1.09-.28",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M889.08,448.85a4.07,4.07,0,0,0,4.71-.84c-.27,1.74-.62,2.74-2.11,3S889.59,449.77,889.08,448.85Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M878.42,457c.28.26-1,2.68-2.08,1.77",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "220.71 139.46 216.08 147.7 217.12 153.41 222.32 144.14 220.71 139.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M929.82,405.15c.39,1.71.4,1.89.46,2.15a3.18,3.18,0,0,0,1.29,2,25.61,25.61,0,0,0,3.53,1.1c.68.2,1.24-.51,1.62-.82s1.5-.91,1.94-.64c.21.13-.91,1-.85,1.23s1.13.08,1.54.07a1.72,1.72,0,0,1,1.74,1.31c.17,1.13-1.29,1.14-1.91,1.25-1.1.19-6.45-.45-8.28-.72s-2.92-.65-3.51-1.64c-.34-.57-1.55-2.79-1.72-3.26s.8-1.45,1.59-1.78S929.71,404.66,929.82,405.15Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M935.53,434.65c1.45.89,3.72,2.65,2,3.31s-5.25-1.22-5.65-2.18a1.73,1.73,0,0,1,.39-2C932.58,433.56,934.6,434.08,935.53,434.65Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M938.59,431.44c1.45.88,3.71,2.64,2,3.31s-5.25-1.22-5.65-2.19a1.72,1.72,0,0,1,.39-2C935.64,430.34,937.65,430.87,938.59,431.44Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M928.3,396.38c-.47,2.95-.53,3.52,0,5.36s-2.44,1.76-2.93,1.65-2.39-3.14-2.19-4.58S928.3,396.38,928.3,396.38Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M928,403.89c1.46,1.31-.83,6.18.47,9.74-2,4.68-7.9,4.53-9.84,5.23-.32-1.34-2.07-2.78-1.65-10-.91-6.14,2.48-8,6.48-8.25,2.9-.18,4.58-.54,6.19,3.55a1.61,1.61,0,0,1-1.19,2.31",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M921.5,401.08a1.9,1.9,0,0,0,2.33,2c1.62-.12,1.34-1.35,1.15-1.71l.19-2.37-3.48-.27Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 205.02,
    cy: 130.26,
    r: 4.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M921.59,391.75c.63.37,1.11,1.68,2.33,1.8s4.09-.63,4.43,1.91c.79-2.21.93-6.75-4.46-6.74s-5.91,5-5.4,7.5c-1.22,2.63-2.18,5.31-1.16,7.78a5.7,5.7,0,0,1,4.16-3.13A18,18,0,0,0,921.59,391.75Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M927.52,418.33s4.48,2.24,5.3,2.71c.59.34,1.91,1.47,2,2.45s.29,5.17.16,6.88,3.55,2.44,3.67,1,.22-8.95.34-10.51-.74-2.11-1.68-2.87a38.54,38.54,0,0,0-10.06-4.51c-.71.07-3.47.79-4.61,1.1",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M922.93,414.43c-2.27.74-4.5,1.82-4.93,3,.66,2.8,1.49,4.5,6,5.35a30.67,30.67,0,0,1,5.71,1.77,3.11,3.11,0,0,1,1.79,2.65c0,.85.24,5.27.29,6.5s3.22,2.15,3.4.43.58-7.57.67-8.71a4.17,4.17,0,0,0-1.5-3.64,56.36,56.36,0,0,0-8-4.48",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "214 140.45 208.8 149.71 215.72 153.59 220.92 144.32 214 140.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M921.38,407.08c0,1.76,0,1.94,0,2.21a3.19,3.19,0,0,0,.81,2.26,27.33,27.33,0,0,0,3.21,1.85c.61.34,1.32-.23,1.76-.44s.87-.6.87,0c0,.24,0,.53,0,.8s1.18.34,1.59.42a1.71,1.71,0,0,1,1.4,1.66c-.08,1.14-1.5.83-2.14.8-1.11-.06-6.19-1.86-7.91-2.53s-2.71-1.28-3.06-2.38c-.21-.62-.9-3.05-1-3.55s1.1-1.24,1.94-1.39S921.38,406.58,921.38,407.08Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M921.82,405.9c-.24.92,0,1.85-1.14,2.67a3.73,3.73,0,0,1-3.75.28,10.87,10.87,0,0,1,0-3.58",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 205.15,
    y1: 130.67,
    x2: 205.11,
    y2: 131.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 207.93,
    y1: 130.19,
    x2: 207.89,
    y2: 130.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M924.18,398.18a1.63,1.63,0,0,0,1.62-.13",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M925.75,396.92a.81.81,0,0,1-.88.38",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 204.44,
    y1: 129.97,
    x2: 205.19,
    y2: 129.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 207.52,
    y1: 129.19,
    x2: 208.26,
    y2: 129.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M940.77,408.91s.12.33.17.49a.46.46,0,0,1,0,.42.25.25,0,0,1-.12.08.48.48,0,0,1-.18,0,1,1,0,0,1-.38-.05",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M940.94,409.81l-5.19,9.25,0,0c-.21.24-.89,0-1.38-.25l5.2-9.27a2.42,2.42,0,0,0,1.1.35.48.48,0,0,0,.18,0,.25.25,0,0,0,.12-.08Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M936.6,481.57c-5.32-3.07-13.92-3.07-19.2,0s-5.25,8.05.06,11.12,13.91,3.07,19.2,0,5.26-8.05-.06-11.12",
    transform: "translate(-718.62 -265.26)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M939.14,478.12c.53,1.13-.32,3.43.26,4.53.48.94,2,1.12,2.43.23a25.39,25.39,0,0,0,1-4.07c.21-1,.54-2-.39-2.52s-1.7-1.11-2.21-.46A10.37,10.37,0,0,0,939.14,478.12Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M939.27,481.79a2.11,2.11,0,0,1,2.74,0",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M920.92,483.39c-.67.94-3.06,2.81-3.46,3.83-.48,1.24,1.25,1.81,1.59,1.64s3.21-1.73,3.84-2.08A1.73,1.73,0,0,0,924,485c0-1,0-1.64-.73-1.76A9.82,9.82,0,0,0,920.92,483.39Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M918.26,486.23a2.06,2.06,0,0,1,2.15,1.8",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M921.79,459.42c-1.35.64-2,.35-2.56-.5s.26-1.19.93-1.52c.86-.43-.41.4-.63-.17-.14-.36.27-.49.8-.65s1.62.06,1.82-.23c.43-.6,2.06-3.15,1.85-3.41s-.77-.69-1.67-1.47,1-3.45,1.78-2.87a16,16,0,0,1,2.58,2.55c.73.88.45,1.37-.35,2.67a34.47,34.47,0,0,1-3.06,4.3A6.33,6.33,0,0,1,921.79,459.42Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M920.45,457.28c.42-.06.89.82.82,1.12a.54.54,0,0,1-.39.38",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M923.42,450.06c-1,.2-2.07.77-2.37.14a3.22,3.22,0,0,1-.37-2.7c.79-1.84,3.23-1.88,5.05-1.82h.33",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M923.09,460.91c-1.13,5-1.29,6.3-1.76,8.58a11,11,0,0,0-.47,3.73c.15,2.84-.15,7.69,0,10.39.1,2.46,2.32,1.49,2.58,0,.29-1.67,1.9-7.53,1-12.1.61-1.78,3-5.19,3.56-7",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M929,462.05c-.2.5-.5.9-1.2,2.5s-5.38-.54-5.11-1.81c.22-1,.26-1.09.66-2.61.3-1.16,2.35-1.22,3.57-.86",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M927.56,464.33c.58,5.1.42,2.8.72,5.1s.5,2.59,1.64,3.41a83.53,83.53,0,0,0,9.48,5.39c2.21,1.09,2.47-1.23,1.24-2.21s-5.93-6-8.83-5.67c0-1.89,1.16-5.9,1.08-7.75",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M927.68,458.41c1.9-.39,4.77-.2,5.42.63s.29,2.45.15,3.39-.33,1.37-.47,2.3c-.25,1.59-5,1.62-5.22-.4-.07-.55-.11-.76-.11-.76",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M922.31,449.25c-2,4.28.47,5,.72,6.26.33,1.62.7,1.22.27,5a8.25,8.25,0,0,0,9.93-.25c-.26-3.46-1.16-4.92-1.26-6a8.06,8.06,0,0,0-.22-1.18c-.11-.78-.26-4.91-.54-5.41s-.7-.8-2.39-1.43",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M926.36,445.71c1.9.09,5.24.24,6.24,2a9.57,9.57,0,0,1,1,5.94c0-1.19-3.19-1.32-3.32-.34-.11-2-.28-3.24-.28-3.24",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M927.93,446.06c-.12.35-.07,3.21-2.68,3.09-2.18-.09-1-2.51-.76-2.93l-.3-2.65,3.39-.61Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 206.94,
    cy: 174.19,
    r: 5.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 206.71,
    y1: 174.83,
    x2: 207.32,
    y2: 174.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 203.29,
    y1: 174.44,
    x2: 203.9,
    y2: 174.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 207.02,
    cy: 174.85,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 203.59,
    cy: 174.47,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 204.68,
    cy: 166.12,
    r: 2.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M925.11,442.69a1.79,1.79,0,0,1-1.81-.07",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M923.09,441.21a.9.9,0,0,0,1,.39",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 212.23,
    y1: 173.95,
    x2: 208.43,
    y2: 174.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 205.72,
    y1: 174.33,
    x2: 204.98,
    y2: 174.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M928,436a3.3,3.3,0,0,0-.82,2.05c-.83,0-8.24-.87-8.24-.87a6.61,6.61,0,0,1,6.28-5.19c4-.2,6.55,1.83,6.49,6,.06,1.87-.77,3.33-1.3,3.45C931.56,439.66,929,436.64,928,436Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M923.44,457.58c-1.3-.74-1.52-1.16-1.17-2.14s1.24-.72,1.9-.35c.84.46-.62-.31-.12-.43a1.08,1.08,0,0,1,1,.13c.58.37.74,1.33,1.16,1.33.74,0,3.77-.12,3.85-.44s.13-1,.26-2.22,3.4-1.14,3.37-.19a15.51,15.51,0,0,1-.61,3.59c-.3,1.1-.86,1.15-2.39,1.24a35.33,35.33,0,0,1-5.28,0A6.76,6.76,0,0,1,923.44,457.58Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 212.23,
    cy: 167.45,
    r: 2.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M930,439.4a1,1,0,0,1,.69-.25,1.16,1.16,0,0,1,1.06,1.26,1.18,1.18,0,0,1-1.13,1.21,1.06,1.06,0,0,1-.81-.45",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 86.73,
    cy: 254.83,
    rx: 13.78,
    ry: 7.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M83.29,238.83h6.9a0,0,0,0,1,0,0v14.44a3.45,3.45,0,0,1-3.45,3.45h0a3.45,3.45,0,0,1-3.45-3.45V238.83A0,0,0,0,1,83.29,238.83Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 86.73,
    cy: 205.39,
    r: 35.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M826.07,493.8a34.76,34.76,0,0,1-26.37-57.39,34.76,34.76,0,1,0,32,56.93A34,34,0,0,1,826.07,493.8Z",
    transform: "translate(-718.62 -265.26)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "397.95 262.57 387.67 268.36 386.38 267.62 396.67 261.87 397.95 262.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "398.03 273.83 387.64 279.95 387.81 268.36 397.95 262.57 398.03 273.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "389.06 261.33 392.69 259.32 396.67 261.87 393.26 263.77 389.06 261.33"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1011,311.26c-1.52-.87-3-.74-3,1.12a5.94,5.94,0,0,0,2.53,4.47c.68.5,1.43,1.25,1.41,1.76s-.45.47-1,.17a4.83,4.83,0,0,1-1.73-1.92l-1.33.66a7.76,7.76,0,0,0,2.81,3.34c1.51.88,3.19.84,3.26-1,.1-2.26-1.36-3.7-2.83-4.85a2.55,2.55,0,0,1-1.1-1.52c0-.56.43-.61.93-.32a4.18,4.18,0,0,1,1.45,1.6l1.37-.41a7,7,0,0,0-2.81-3.14m13.9,8c-1.71-1-3.41-.9-3.42,1.29v3.24c0,2.16,1.7,4.23,3.42,5.23s3.42.88,3.42-1.28v-3.25c0-2.17-1.71-4.24-3.42-5.23m-6.91-4c-1.65-1-3.29-.8-3.29,1.33v3.27a6.42,6.42,0,0,0,3.24,5.12c1,.6,2.29.73,3-.41l-1.82-2c-.2.47-.7.45-1.18.17a2.21,2.21,0,0,1-1.14-1.66h0v-3.28c0-.65.57-.69,1.17-.34a2.91,2.91,0,0,1,1.23,1.46l1.7.2a6.63,6.63,0,0,0-2.9-3.85m22,12.84-3.08-1.77v4l2,3.3V329.8l1.1.63a1.86,1.86,0,0,1,1,1.61V335c0,.63-.33.85-1,.44l-3.16-1.83v2.25l3.1,1.79,0,0c1.64.95,3.17.87,3.17-1.28v-3.19a6.11,6.11,0,0,0-3.19-5m-33-19-2.08-1.2,0,9.48,2.08,1.2,0-9.48m-6.39-3.69h0m0,0-3.09-1.78v4l2,3.31v-3.87l1.1.63a1.84,1.84,0,0,1,1,1.61v2.95c0,.63-.32.85-1,.44l-3.16-1.83v2.26l3.08,1.78,0,0c1.64.95,3.17.87,3.18-1.28v-3.19a6.11,6.11,0,0,0-3.19-5m32.1,18.55-3.3-1.91,0,9.48,2.11,1.22v-3l.37.21,1.9,4.12,2.6,1.5L1034.1,331c1,.22,1.62-.42,1.63-2.17h0a5.67,5.67,0,0,0-3-4.88m-47.07-22.86c-.52-.31-.94,0-1,.62a2.18,2.18,0,0,0,1,1.72c.53.31.95,0,.95-.62a2.15,2.15,0,0,0-.95-1.72m-3.39-2c-.52-.3-.94,0-1,.63a2.19,2.19,0,0,0,1,1.72c.52.3.95,0,.95-.63a2.12,2.12,0,0,0-.95-1.72m49.26,28.53v-2.17l1.22.71c1.31.75,1.3,2.93,0,2.17l-1.22-.71m-6.64-.84a2.41,2.41,0,0,1-1.33-1.81v-3.23c0-.7.65-.7,1.3-.32a2.47,2.47,0,0,1,1.37,1.86v3.23c0,.68-.68.65-1.33.27m-37.21-27a13.54,13.54,0,0,0-2.31-2.69l.13-.09h0a9,9,0,0,1,2.59,2.6,22.72,22.72,0,0,1,1.32,6.95h0s-.8,1.06-2.84,0l-.61-1.21c1.22.31,1.68-.29,1.68-.29a3.52,3.52,0,0,1-1.07,0,5.59,5.59,0,0,1-1.34-.33,7.94,7.94,0,0,1-1.18-.55,12.62,12.62,0,0,1-1.23-.84,15.72,15.72,0,0,1-1.37-1.25c-.23-.24-.45-.49-.67-.75l-.08-.11,0,0c-.17-.2-.26-.33-.26-.33a6.67,6.67,0,0,0,1.62,2.18c-.28.25-.62.52-.62.52a7.35,7.35,0,0,1-2.83-3.24,10.29,10.29,0,0,1,1.36-5.4,3.56,3.56,0,0,1,2.58.39h0l.09.18a3.72,3.72,0,0,0-2.44,0,4.5,4.5,0,0,1,.55,0,6.18,6.18,0,0,1,2.11.55l.16.07a8.7,8.7,0,0,1,1,.51c.29.16.58.35.87.55a14.75,14.75,0,0,1,2.79,2.63m2.52-5-12.44-7.19c-1.06-.61-1.91-.11-1.91,1.1l0,14.3a4.17,4.17,0,0,0,1.89,3.28l10.53,6.08-.48-2.24,1.18,1.94,1.12,1.84,2,3.16,0-19a4.25,4.25,0,0,0-1.91-3.3",
    transform: "translate(-718.62 -265.26)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M761.83,426.29a9.28,9.28,0,0,1-1.85.59v0a3.13,3.13,0,0,0,1.41-1.83,5.9,5.9,0,0,1-2.08.84,3.3,3.3,0,0,0-2.32-1,3.24,3.24,0,0,0-3.18,4c-3.29,0-5.74-2.26-6.63-3.15a3.24,3.24,0,0,0,1,4.24,2.22,2.22,0,0,1-1.37-.34,2.85,2.85,0,0,0,2.54,3.14,2.75,2.75,0,0,1-1.41.14,3.38,3.38,0,0,0,3,2.17,7.39,7.39,0,0,1-4.68,1.4,8.93,8.93,0,0,0,10.53-.6c3.18-2.48,3.42-6.69,3.43-7.64,0,0,0,0,0-.06V428h0A5.24,5.24,0,0,0,761.83,426.29Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M801.59,463a7.8,7.8,0,0,0,1.82-.66v0a3.08,3.08,0,0,1-2.24-.57,6.28,6.28,0,0,0,2.16-.62,3.26,3.26,0,0,1,5.8-1.63,3.13,3.13,0,0,1,.37.6c2.59-2,3.13-5.31,3.28-6.56a3.23,3.23,0,0,1,1.82,4c.54-.29.64-.7.88-1.1a2.86,2.86,0,0,1-.07,4,3,3,0,0,0,1.19-.76,3.39,3.39,0,0,1-1,3.56,7.39,7.39,0,0,0,4.55-1.77,9,9,0,0,1-8.67,6c-4,0-6.81-3.17-7.41-3.92l0,0,0,0-.06-.07h0A5.35,5.35,0,0,1,801.59,463Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M752.16,398.79h-9.3a8.67,8.67,0,0,0-8.64,8.64h0a8.67,8.67,0,0,0,8.64,8.65h12.62l4,4.2a.75.75,0,0,0,1.29-.52V407.43A8.67,8.67,0,0,0,752.16,398.79Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M812.46,436.41h7.6a7.1,7.1,0,0,1,7.08,7.07h0a7.11,7.11,0,0,1-7.08,7.08H809.74l-3.3,3.44a.62.62,0,0,1-1.06-.43V443.48A7.1,7.1,0,0,1,812.46,436.41Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1045.51,349.65h9.67a9,9,0,0,1,9,9h0a9,9,0,0,1-9,9h-13.12l-4.18,4.36a.78.78,0,0,1-1.35-.54v-12.8A9,9,0,0,1,1045.51,349.65Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M983.54,533.82h9.19a8.56,8.56,0,0,1,8.54,8.54h0a8.56,8.56,0,0,1-8.54,8.54H980.26l-4,4.15a.74.74,0,0,1-1.28-.51V542.36A8.57,8.57,0,0,1,983.54,533.82Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1020.25,535.47h-5.78a5.39,5.39,0,0,0-5.37,5.37h0a5.39,5.39,0,0,0,5.37,5.37h7.84l2.5,2.61a.47.47,0,0,0,.81-.32v-7.66A5.39,5.39,0,0,0,1020.25,535.47Z",
    transform: "translate(-718.62 -265.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M798,408.12a8.32,8.32,0,0,0,1.82-.66v0a3.08,3.08,0,0,1-2.25-.58,6.14,6.14,0,0,0,2.17-.61,3.17,3.17,0,0,1,1.23-2.19,3.25,3.25,0,0,1,4.57.56,3.13,3.13,0,0,1,.37.6c2.59-2,3.13-5.31,3.28-6.56a3.24,3.24,0,0,1,1.82,4c.54-.29.64-.71.88-1.1a2.85,2.85,0,0,1-.08,4,2.71,2.71,0,0,0,1.19-.75,3.37,3.37,0,0,1-1,3.56,7.39,7.39,0,0,0,4.55-1.77,8.93,8.93,0,0,1-8.67,6c-4,0-6.81-3.16-7.41-3.91l0,0s0,0,0,0l-.06-.08h0A5.16,5.16,0,0,1,798,408.12Z",
    transform: "translate(-718.62 -265.26)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityCenter);
export default __webpack_public_path__ + "static/media/community-center.499b3606a1fa51e5162cd4bcfd03f0c8.svg";
export { ForwardRef as ReactComponent };